import React, { useState, startTransition, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import SelectList, { components } from "react-select";

// Register AG Grid modules
ModuleRegistry.registerModules([AllCommunityModule]);

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  addIsbnPage,
  fetchIsbnList,
  removeFetchType,
  resetIsbnPage,
  setIsbnNumberOptions,
  setIsbnString,
  setIsbnTitleOptions,
  UpdateSelectedISBNS,
  UpdateSelectedISBNSList,
  UpdateSelectedTitles,
  UpdateSelectedTitlesList,
} from "../../redux/reducers/ISBNSReducer";
import {
  debounceAsync,
  formatCurrency,
} from "../../common-components/commonFunctions";
import {
  addPage,
  FetchAuthor1,
  removeAuthorFetchType,
  resetAuthorPage,
  setAuthorString,
  UpdateAuthor1,
  UpdateAuthor1List,
} from "../../redux/reducers/AUTHOR1Reducer";
import MultiSelect from "../../common-components/CommonCheckBoxMultiSelect";
import {
  FetchbisacStatus,
  UpdatebisacStatus,
  UpdatebisacStatusList,
} from "../../redux/reducers/BisanStatusReducer";
import {
  FetchEditor,
  UpdateEditor,
  UpdateEditorList,
} from "../../redux/reducers/editorReducer";
import {
  FetchManagingEditor,
  UpdatemanagingEditor,
  UpdatemanagingEditorList,
} from "../../redux/reducers/managingEditorReducer";
import {
  FetchSeason,
  UpdateSelectedSeason,
  UpdateSelectedSeasonList,
} from "../../redux/reducers/SeasonReducer";
import {
  fetchImprint,
  UpdateSelectedImprint,
  UpdateSelectedImprintList,
} from "../../redux/reducers/ImprintReducer";
import {
  fetchDivision,
  UpdateSelectedDivision,
  UpdateSelectedDivisionList,
} from "../../redux/reducers/DivisionReducer";
import {
  fetchFormat,
  UpdateSelectedFormat,
  UpdateSelectedFormatList,
} from "../../redux/reducers/formatReducer";
import {
  FetchTitleListRecord,
  resetTitleListPage,
  RLSApi,
} from "../../redux/reducers/TitleListreducer";
import { emptyDetailsPageRecord } from "../../redux/reducers/DetailPageReducer";
import { setresetFiltersInexport } from "../../redux/reducers/TmmExportLinkReducer";
import Loading from "../../common-components/Loader";
import { user } from "../../redux/reducers/UserReducer";
import Alogo from "../../assets/images/logo.png";

var BASE_URL = process.env.REACT_APP_BASE_URL;
interface OptionType {
  value: string;
  label: string;
}
interface FormValues {
  season: string[];
  division: string[];
  imprint: string[];
  managingEditor: string[];
  editor: string[];
  bisac_status: string[];
  format: string[];
  author: OptionType[];
  title: OptionType[];
  isbn: OptionType[];
}
declare global {
  interface Window {
    startTmmLiveData: () => void;
  }
}
const TmmExport: React.FC = () => {
  const [rowData, setRowData] = useState<any[]>([]);
  const [columnDefs, setColumnDefs] = useState<any[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const isbnReducer = useSelector((state: RootState) => state.isbnReducer);
  const authorReducer = useSelector((state: RootState) => state.AUTHOR1Reducer);
  // const [filtersDisabled, setFiltersDisabled] = useState(true);
  const userData = useSelector(user);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [onMultiSearchSelect, setOnMultiSearchSelect] =
    useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadedRecords, setLoadedRecords] = useState(0);
  const [showPopup, setShowPopup] = useState(true);
  const [displayedCount, setDisplayedCount] = useState(0);
  const [filteredCount, setFilteredCount] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isDataLoadingComplete, setIsDataLoadingComplete] = useState(false);
  const [hasGridColumnFilters, setHasGridColumnFilters] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const gridApiRef = useRef<any>(null);

  // keep previous filter model to detect removals/changes
  const prevFilterModelRef = useRef<any>({});

  // Track if columns are initialized to avoid re-setting them
  const columnsInitializedRef = useRef<boolean>(false);

  // Batch queue to accumulate updates and reduce re-renders
  const batchQueueRef = useRef<any[]>([]);

  // Queue for pending filter changes while data is loading
  const pendingFiltersRef = useRef<{ type: 'isbn' | 'title' | 'other', values: any[], field?: string }[]>([]);
  const batchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const filtersEnabledRef = useRef<boolean>(false);
  const isClearingFiltersRef = useRef<boolean>(false); // Flag to prevent grid sync during manual clear
  const isSelectingIsbnsRef = useRef<boolean>(false); // Flag to prevent grid sync from removing ISBNs when selecting
  const lastTitleSelectionRef = useRef<string>(""); // Track last title selection to prevent duplicate processing

  // Debounce timer for filter changes to prevent multiple rapid applications
  const filterDebounceTimerRef = useRef<Promise<void> | null>(null);

  // Helper function to create a promise-based delay
  const delay = (ms: number): Promise<void> => {
    return new Promise((resolve) => {
      // Use requestAnimationFrame for 0ms delays, setTimeout for others
      if (ms === 0) {
        requestAnimationFrame(() => resolve());
      } else {
        setTimeout(resolve, ms);
      }
    });
  };

  // Flag to track if filter is being applied to prevent duplicate calls
  const isApplyingFilterRef = useRef<boolean>(false);


  const resetFiltersInexport = useSelector(
    (state: RootState) => state.TmmExportLinkReducer.resetFiltersInexport
  );


  const rawData = useSelector((state: RootState) => state.TitleListreducer.dataOfRls);

  let dataofrls =
    rawData && rawData.length > 0 && rawData.some(v => v.VALUE)
      ? rawData
      : (rawData?.[0]?.COLUMN === "0" && rawData?.[0]?.VALUE === "0"
        ? rawData
        : null);
  const hasStar = dataofrls?.some(v => v.VALUE === "*");
  const column = hasStar ? null : dataofrls?.[0]?.COLUMN ?? null;

  const value = hasStar
    ? []
    : dataofrls
      ? dataofrls
        .flatMap(v =>
          v.VALUE
            ? v.VALUE.split(",").map((str: any) => str.trim()).filter(Boolean)
            : []
        )
      : [];

  const hasFetchedData = useRef(false);
  const previousDataofRls = useRef(dataofrls);
  // const value =
  //   hasStar
  //     ? []
  //     : dataofrls
  //     ? dataofrls.map(v => v.VALUE ?? "").filter(v => v !== "")
  //     : [];
  const { control, watch, setValue } = useForm<FormValues>({
    defaultValues: {
      author: [],
      bisac_status: [],
      division: [],
      editor: [],
      format: [],
      imprint: [],
      isbn: [],
      managingEditor: [],
      season: [],
      title: [],
    },
  });
  const selectedManagingEditors = useSelector(
    (state: RootState) => state.managingEditorReducer.managingEditor
  );
  const selectedEditors = useSelector(
    (state: RootState) => state.editorReducer.Editor
  );
  const selectedBisacStatus = useSelector(
    (state: RootState) => state.BisanStatusReducer.bisacStatus
  );

  const TitleListReducer = useSelector(
    (state: RootState) => state.TitleListreducer
  );
  const seasonReducer = useSelector((state: RootState) => state.SeasonReducer);
  const divisionReducer = useSelector(
    (state: RootState) => state.DivisionReducer
  );
  const managingEditorReducer = useSelector(
    (state: RootState) => state.managingEditorReducer
  );
  const editorReducer = useSelector((state: RootState) => state.editorReducer);
  const bisanStatusReducer = useSelector(
    (state: RootState) => state.BisanStatusReducer
  );
  const imprintReducer = useSelector(
    (state: RootState) => state.ImprintReducer
  );
  const formatReducer = useSelector((state: RootState) => state.FormatReducer);
  const options = seasonReducer.data.map(
    (SeasonData) => SeasonData.SEASON ?? ""
  );
  const managingEditorOptions = managingEditorReducer.data.map(
    (managingEditor) => managingEditor.MANAGING_EDITOR ?? ""
  );
  const editorOptions = editorReducer.data.map((editor) => editor.EDITOR ?? "");
  const bisacStatusOptions = bisanStatusReducer.data.map(
    (bisacStatus) => bisacStatus.BISAC_STATUS ?? ""
  );
  const DivisionOption = divisionReducer.data.map(
    (Division) => Division.division ?? ""
  );
  const ImprintOption = imprintReducer.data.map((imprint) => imprint.IMPRINT);
  const FormatOption = formatReducer.data.map((format) => format.FORMAT);
  const filteredNew =
    selectedManagingEditors?.length !== watch("managingEditor")?.length ||
    selectedEditors?.length !== watch("editor")?.length ||
    selectedBisacStatus?.length !== watch("bisac_status")?.length ||
    authorReducer.Author1?.length !== watch("author")?.length ||
    seasonReducer.selectedSeason?.length !== watch("season")?.length ||
    divisionReducer.selectedDivision?.length !== watch("division")?.length ||
    imprintReducer.selectedImprint?.length !== watch("imprint")?.length ||
    isbnReducer.selectedISBNS?.length !== watch("isbn")?.length ||
    formatReducer.selectedFormat?.length !== watch("format")?.length;
  useEffect(() => {
    if (userData?.email) {
      dispatch(RLSApi({ email: userData?.email, report_id: "4" }));
    }
  }, [dispatch, userData?.email]);
  // OPTIMIZATION: Debounce onFilterChanged to prevent excessive calls
  const onFilterChangedDebouncedRef = useRef<Promise<void> | null>(null);

  const onFilterChanged = () => {
    // Clear any pending debounce by creating a new promise
    // The old promise will still complete but won't affect the new filter change

    // Debounce the filter changed handler using Promise
    const debouncePromise = delay(50);
    onFilterChangedDebouncedRef.current = debouncePromise;

    debouncePromise.then(() => {
      if (!gridApi) return;

      const filterModel = gridApi.getFilterModel();
      const hasFilters = Object.keys(filterModel).length > 0;
      const count = gridApi.getDisplayedRowCount();

      // Track if grid column filters are active for button enable/disable
      setHasGridColumnFilters(hasFilters);

      // update the counter
      setDisplayedCount(hasFilters ? count : 0);

      if (hasFilters && count === 0) {
        gridApi.showNoRowsOverlay();
      } else {
        gridApi.hideOverlay();
      }
      // --- Sync grid filters back to the normal filters ---
      // Skip sync if we're in the middle of a manual clear operation or selecting ISBNs
      if (isClearingFiltersRef.current || isSelectingIsbnsRef.current) {
        return;
      }

      try {
        const prev = prevFilterModelRef.current || {};
        const current = filterModel || {};

        // mapping from grid column keys to form field names
        // Note: Division column in SQL is GROUP_1, not DIVISION
        const colToField: Record<string, string> = {
          EAN: "isbn",
          ISBN: "isbn",
          ISBN_9: "isbn",
          ISBN_10: "isbn",
          PARENT_ISBN: "isbn",
          FULL_TITLE: "title",
          AUTHOR_1: "author",
          SEASON: "season",
          GROUP_1: "division", // Division column is GROUP_1 in SQL
          DIVISION: "division", // Also map DIVISION for backward compatibility
          IMPRINT: "imprint",
          FORMAT: "format",
          MANAGING_EDITOR: "managingEditor",
          EDITOR: "editor",
          BISAC_STATUS: "bisac_status",
        };

        const getConditions = (model: any, col: string) => {
          if (!model || !model[col]) return [];
          const entry = model[col];
          // ag-grid stores conditions under .conditions (array) or single .filter
          if (Array.isArray(entry.conditions)) return entry.conditions.map((c: any) => String(c.filter));
          if (entry.filter !== undefined) return [String(entry.filter)];
          return [];
        };

        // OPTIMIZATION: helper to build OptionType arrays from labels for isbn/title/author
        // Uses Maps for O(1) lookups instead of nested loops
        const buildOptionList = (labels: string[] | undefined, optionsList: any[]) => {
          if (!labels || !labels.length) return [];

          // OPTIMIZATION: Create Sets for O(1) lookups
          const labelSet = new Set<string>();
          for (let i = 0; i < labels.length; i++) {
            labelSet.add(String(labels[i]));
          }

          // OPTIMIZATION: Single pass through optionsList with Map for deduplication
          const matchedMap = new Map<string, any>();
          const valueSet = new Set<string>();

          for (let i = 0; i < optionsList.length; i++) {
            const opt = optionsList[i];
            if (!opt) continue;

            const optLabel = String(opt.label || '');
            const optValue = String(opt.value || '');

            // Check if label or value matches
            if (labelSet.has(optLabel) || labelSet.has(optValue)) {
              const key = optValue || optLabel;
              if (key && !matchedMap.has(key)) {
                matchedMap.set(key, opt);
                valueSet.add(optValue);
              }
            }
          }

          let result: any[] = [];
          if (matchedMap.size > 0) {
            // Use matched options
            result = Array.from(matchedMap.values());
          } else {
            // OPTIMIZATION: Fallback - build from labels using Map for deduplication
            const fallbackMap = new Map<string, any>();
            for (let i = 0; i < labels.length; i++) {
              const l = String(labels[i]);
              if (!fallbackMap.has(l)) {
                fallbackMap.set(l, { value: l, label: l });
              }
            }
            result = Array.from(fallbackMap.values());
          }

          return result;
        };

        // iterate union of keys
        const keys = Array.from(new Set([...Object.keys(prev), ...Object.keys(current)]));
        for (const col of keys) {
          const field = colToField[col];
          if (!field) continue; // not a mapped field

          const prevVals = getConditions(prev, col);
          const curVals = getConditions(current, col);

          // if both empty and unchanged, skip
          const prevSet = new Set(prevVals);
          const curSet = new Set(curVals);
          let equal = prevVals.length === curVals.length && prevVals.every((v: any) => curSet.has(v));
          if (equal) continue;

          // if current is empty -> clear normal filter
          if (curVals.length === 0) {
            // clear form value and redux for this field
            if (field === "isbn") {
              // Only clear ISBN and title if ISBN filter is manually cleared from grid
              // Don't auto-clear if it was cleared due to missing titles
              setValue("isbn", []);
              setValue("title", []);
              dispatch(UpdateSelectedISBNS([]));
              dispatch(UpdateSelectedISBNSList([]));
              dispatch(UpdateSelectedTitles([]));
              dispatch(UpdateSelectedTitlesList([]));
            } else if (field === "title") {
              // When title filter is cleared from grid, ONLY clear titles
              // DO NOT clear ISBNs - ISBNs should remain selected even without titles
              setValue("title", []);
              dispatch(UpdateSelectedTitles([]));
              dispatch(UpdateSelectedTitlesList([]));
              // DO NOT clear ISBNs here - they should remain selected
            } else if (field === "author") {
              setValue("author", []);
              dispatch(UpdateAuthor1([]));
              dispatch(UpdateAuthor1List([]));
            } else if (field === "season") {
              setValue("season", []);
              dispatch(UpdateSelectedSeason([]));
              dispatch(UpdateSelectedSeasonList([]));
            } else if (field === "division") {
              setValue("division", []);
              dispatch(UpdateSelectedDivision([]));
              dispatch(UpdateSelectedDivisionList([]));
            } else if (field === "imprint") {
              setValue("imprint", []);
              dispatch(UpdateSelectedImprint([]));
              dispatch(UpdateSelectedImprintList([]));
            } else if (field === "format") {
              setValue("format", []);
              dispatch(UpdateSelectedFormat([]));
              dispatch(UpdateSelectedFormatList([]));
            } else if (field === "managingEditor") {
              setValue("managingEditor", []);
              dispatch(UpdatemanagingEditor([]));
              dispatch(UpdatemanagingEditorList([]));
            } else if (field === "editor") {
              setValue("editor", []);
              dispatch(UpdateEditor([]));
              dispatch(UpdateEditorList([]));
            } else if (field === "bisac_status") {
              setValue("bisac_status", []);
              dispatch(UpdatebisacStatus([]));
              dispatch(UpdatebisacStatusList([]));
            }
          } else {
            // current has some values -> set normal filter selection to match grid
            if (field === "isbn") {
              // Get current options from reducer to ensure we have the latest values
              const currentNumberOptions = isbnReducer.numberOptions || [];
              const currentTitleOptions = isbnReducer.titleOptions || [];

              // map isbn options to titles by shared value (isbn _id)
              const selectedIsbns = buildOptionList(curVals, currentNumberOptions);
              // OPTIMIZATION: Use Map for O(1) lookups instead of Array
              const uniqueIsbnsMap = new Map<string, any>();
              for (let i = 0; i < selectedIsbns.length; i++) {
                const item = selectedIsbns[i];
                if (item && item.value) {
                  uniqueIsbnsMap.set(String(item.value), item);
                }
              }
              const uniqueIsbns = Array.from(uniqueIsbnsMap.values());

              // OPTIMIZATION: Use Set for O(1) lookups instead of .some() which is O(n)
              const isbnValueSet = new Set<string>();
              uniqueIsbns.forEach((i: any) => {
                if (i && i.value) isbnValueSet.add(String(i.value));
              });

              // find matching titles that share the same .value (isbn _id)
              const matchedTitlesMap = new Map<string, any>();
              for (let i = 0; i < currentTitleOptions.length; i++) {
                const t = currentTitleOptions[i];
                if (t && t.value && isbnValueSet.has(String(t.value))) {
                  matchedTitlesMap.set(String(t.value), t);
                }
              }
              const uniqueTitles = Array.from(matchedTitlesMap.values());

              // IMPORTANT: Always keep all selected ISBNs, even if they don't have titles
              // Only set titles that actually exist - don't remove ISBNs without titles
              setValue("isbn", uniqueIsbns as any);
              setValue("title", uniqueTitles as any);
              dispatch(UpdateSelectedISBNS(uniqueIsbns));
              dispatch(UpdateSelectedISBNSList(uniqueIsbns));
              dispatch(UpdateSelectedTitles(uniqueTitles));
              dispatch(UpdateSelectedTitlesList(uniqueTitles));
            } else if (field === "title") {
              // Get current options from reducer to ensure we have the latest values
              const currentNumberOptions = isbnReducer.numberOptions || [];
              const currentTitleOptions = isbnReducer.titleOptions || [];

              // map title options to isbn options by shared value (isbn _id)
              const selectedTitles = buildOptionList(curVals, currentTitleOptions);
              // OPTIMIZATION: Use Map for O(1) lookups instead of Array
              const uniqueTitlesMap = new Map<string, any>();
              for (let i = 0; i < selectedTitles.length; i++) {
                const item = selectedTitles[i];
                if (item && item.value) {
                  uniqueTitlesMap.set(String(item.value), item);
                }
              }
              const uniqueTitles = Array.from(uniqueTitlesMap.values());

              // OPTIMIZATION: Use Set for O(1) lookups instead of .some() which is O(n)
              const titleValueSet = new Set<string>();
              uniqueTitles.forEach((t: any) => {
                if (t && t.value) titleValueSet.add(String(t.value));
              });

              // Find matching ISBNs for selected titles
              const matchedIsbnsMap = new Map<string, any>();
              for (let i = 0; i < currentNumberOptions.length; i++) {
                const n = currentNumberOptions[i];
                if (n && n.value && titleValueSet.has(String(n.value))) {
                  matchedIsbnsMap.set(String(n.value), n);
                }
              }
              const uniqueIsbns = Array.from(matchedIsbnsMap.values());

              // Update titles first
              setValue("title", uniqueTitles as any);
              dispatch(UpdateSelectedTitles(uniqueTitles));
              dispatch(UpdateSelectedTitlesList(uniqueTitles));

              // Only update ISBNs that have matching titles
              // But keep any existing ISBNs that don't have titles (preserve ISBNs without titles)
              // OPTIMIZATION: Use Set for O(1) lookups instead of .some() which is O(n)
              const titleValueSetForKeep = new Set<string>();
              uniqueTitles.forEach((t: any) => {
                if (t && t.value) titleValueSetForKeep.add(String(t.value));
              });

              const currentIsbns = watch("isbn") || [];
              const isbnsToKeep: any[] = [];
              for (let i = 0; i < currentIsbns.length; i++) {
                const isbn = currentIsbns[i];
                if (isbn && isbn.value && !titleValueSetForKeep.has(String(isbn.value))) {
                  isbnsToKeep.push(isbn);
                }
              }
              const finalIsbns = [...uniqueIsbns, ...isbnsToKeep];

              setValue("isbn", finalIsbns as any);
              dispatch(UpdateSelectedISBNS(finalIsbns));
              dispatch(UpdateSelectedISBNSList(finalIsbns));
            } else if (field === "author") {
              const selected = buildOptionList(curVals, authorOptions);
              const unique = Array.from(new Map(selected.map((s: any) => [String(s.value ?? s.label), s])).values());
              // dispatch wants labels for UpdateAuthor1
              const labels = unique.map((s: any) => s.label ?? s.value);
              setValue("author", unique as any);
              dispatch(UpdateAuthor1(labels));
              dispatch(UpdateAuthor1List(unique));
            } else if (field === "season") {
              const unique = Array.from(new Set(curVals)) as string[];
              setValue("season", unique);
              dispatch(UpdateSelectedSeason(unique));
              dispatch(UpdateSelectedSeasonList(unique));
            } else if (field === "division") {
              const unique = Array.from(new Set(curVals)) as string[];
              setValue("division", unique);
              dispatch(UpdateSelectedDivision(unique));
              dispatch(UpdateSelectedDivisionList(unique));
            } else if (field === "imprint") {
              const unique = Array.from(new Set(curVals)) as string[];
              setValue("imprint", unique);
              dispatch(UpdateSelectedImprint(unique));
              dispatch(UpdateSelectedImprintList(unique));
            } else if (field === "format") {
              const unique = Array.from(new Set(curVals)) as string[];
              setValue("format", unique);
              dispatch(UpdateSelectedFormat(unique));
              dispatch(UpdateSelectedFormatList(unique));
            } else if (field === "managingEditor") {
              const unique = Array.from(new Set(curVals)) as string[];
              setValue("managingEditor", unique);
              dispatch(UpdatemanagingEditor(unique));
              dispatch(UpdatemanagingEditorList(unique));
            } else if (field === "editor") {
              const unique = Array.from(new Set(curVals)) as string[];
              setValue("editor", unique);
              dispatch(UpdateEditor(unique));
              dispatch(UpdateEditorList(unique));
            } else if (field === "bisac_status") {
              const unique = Array.from(new Set(curVals)) as string[];
              setValue("bisac_status", unique);
              dispatch(UpdatebisacStatus(unique));
              dispatch(UpdatebisacStatusList(unique));
            }
          }
        }

        // persist current as previous for next diff
        prevFilterModelRef.current = JSON.parse(JSON.stringify(current));
      } catch (err) {
        console.error("Error syncing grid filters to normal filters:", err);
      }
    });

    onFilterChangedDebouncedRef.current = debouncePromise;
  };
  const onGridReady = (params: any) => {
    gridApiRef.current = params.api;
    setGridApi(params.api);

    // Check if grid has any column filters active on initial load
    if (params.api) {
      const filterModel = params.api.getFilterModel();
      const hasFilters = Object.keys(filterModel || {}).length > 0;
      setHasGridColumnFilters(hasFilters);
    }
    setGridApi(params.api);

    // Setup overlay listeners
    params.api.addEventListener("modelUpdated", () => {
      if (params.api.getDisplayedRowCount() === 0) {
        params.api.showNoRowsOverlay();
      } else {
        params.api.hideOverlay();
      }
    });
  };
  useEffect(() => {
    if (dataofrls !== previousDataofRls.current) {
      hasFetchedData.current = false;
      previousDataofRls.current = dataofrls;
    }
  }, [dataofrls]);

  useEffect(() => {
    if (
      isFetching ||
      hasFetchedData.current ||
      !gridApiRef.current ||
      value[0] == "0"
    ) {
      return;
    }


    setIsFetching(true);
    setIsDataLoadingComplete(false);
    filtersEnabledRef.current = false; // Reset filters enabled flag
    pendingFiltersRef.current = []; // Clear pending filters on new fetch
    initialFiltersAppliedRef.current = false; // Reset to allow filters to be applied again after new data loads

    // Keep grid column filters enabled - users can filter inside the table
    // Only top filter dropdowns are disabled during loading

    // Mark as fetched immediately to prevent duplicate calls
    hasFetchedData.current = true;

    const api = gridApiRef.current;
    api.showLoadingOverlay();

    // Reset columns initialization flag for new fetch
    columnsInitializedRef.current = false;
    setRowData([]);
    setColumnDefs([]);

    const payload = { data: dataofrls };

    const fetchData = async () => {
      try {
        const response = await fetch(`${BASE_URL}tmmExport/fetchTmmExport`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }

        if (!response.body) {
          throw new Error("Readable stream not supported — response.body is null");
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { done, value: chunkValue } = await reader.read();
          if (done) break;
          buffer += decoder.decode(chunkValue, { stream: true });

          const events = buffer.split("\n\n");
          buffer = events.pop() || "";

          for (const event of events) {
            if (event.startsWith("event: total")) {
              const total = Number(event.split("data:")[1]);
              setTotalRecords(total);
            }

            if (event.startsWith("event: progress")) {
              const loaded = Number(event.split("data:")[1]);
              setLoadedRecords(loaded);
            }
            if (event.startsWith("event: end")) {
              setShowPopup(false);
              setIsFetching(false);
              // Set loading complete after all data batches are processed using Promise
              delay(50).then(() => {
                setIsDataLoadingComplete(true);
              });
            }

            if (event.startsWith("event: batch")) {
              try {
                const jsonStr = event.split("data:")[1];
                const newBatch = JSON.parse(jsonStr);

                // Initialize columns on first batch if not already done
                if (newBatch.length > 0 && !columnsInitializedRef.current && columnDefs.length === 0) {
                  const dynamicCols = Object.keys(newBatch[0]).map((key) => {
                    const baseCol = {
                      field: key,
                      headerName: key
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (c) => c.toUpperCase()),
                      sortable: true,
                      resizable: true,
                      headerClass: "custom-header",
                      filter: true,
                      floatingFilter: true,
                      suppressFilterButton: false,
                      filterParams: {
                        buttons: ["apply", "clear"],
                        closeOnApply: true,
                        suppressAndOrCondition: false,
                        filterOptions: [
                          "equals",
                          "notEqual",
                          "contains",
                          "notContains",
                          "startsWith",
                          "endsWith",
                          "lessThan",
                          "lessThanOrEqual",
                          "greaterThan",
                          "greaterThanOrEqual",
                          "inRange",
                          "blank",
                          "notBlank",
                          {
                            displayKey: "countGreaterThan",
                            displayName: "Char Count Greater Than",
                            predicate: (filterValue: any, cellValue: any) => {
                              if (cellValue == null) return false;
                              return String(cellValue).length > Number(filterValue);
                            },
                          },
                          {
                            displayKey: "countLessThan",
                            displayName: "Char Count Less Than",
                            predicate: (filterValue: any, cellValue: any) => {
                              if (cellValue == null) return false;
                              return String(cellValue).length < Number(filterValue);
                            },
                          },
                          {
                            displayKey: "countEquals",
                            displayName: "Char Count Equals",
                            predicate: (filterValue: any, cellValue: any) => {
                              if (cellValue == null) return false;
                              return String(cellValue).length === Number(filterValue);
                            },
                          },
                        ],
                      },
                      valueFormatter: (params: any) =>
                        params.value !== undefined && params.value !== null
                          ? String(params.value)
                          : "",
                    };

                    // Custom formatting for LTD Gross / Return / Net as USD currency
                    if (
                      key === "LTD_Gross" ||
                      key === "LTD_Return" ||
                      key === "LTD_Net"
                    ) {
                      return {
                        ...baseCol,
                        valueFormatter: (params: any) => {
                          const raw = params.value;
                          if (raw === null || raw === undefined || raw === "") return "";
                          const num = Number(raw);
                          if (isNaN(num)) return String(raw);
                          return num.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          });
                        },
                      };
                    }

                    // Custom formatting for Sell Through as percentage with % sign
                    if (key === "Sell_Through_Pct") {
                      return {
                        ...baseCol,
                        valueFormatter: (params: any) => {
                          const raw = params.value;
                          if (raw === null || raw === undefined || raw === "") return "";
                          const num = Number(raw);
                          if (isNaN(num)) return String(raw);
                          const pct = num * 100;
                          return `${pct.toFixed(2)}%`;
                        },
                      };
                    }

                    // Paper Cut Off date: show date only (no time)
                    if (key === "PAPER_CUT_OFF") {
                      return {
                        ...baseCol,
                        valueFormatter: (params: any) => {
                          const raw = params.value;
                          if (raw === null || raw === undefined || raw === "") return "";
                          const d = new Date(raw);
                          if (isNaN(d.getTime())) return String(raw);
                          return d.toLocaleDateString("en-US");
                        },
                      };
                    }

                    // LDC date: show date only (no time)
                    if (key === "LDC") {
                      return {
                        ...baseCol,
                        valueFormatter: (params: any) => {
                          const raw = params.value;
                          if (raw === null || raw === undefined || raw === "") return "";
                          const d = new Date(raw);
                          if (isNaN(d.getTime())) return String(raw);
                          return d.toLocaleDateString("en-US");
                        },
                      };
                    }

                    return baseCol;
                  });

                  setColumnDefs(dynamicCols);
                  columnsInitializedRef.current = true;

                  // Set initial data for first batch
                  setRowData(newBatch);
                } else {
                  // Use AG Grid transaction API for incremental updates to prevent blinking
                  const api = gridApiRef.current;
                  if (api) {
                    // Add rows using transaction API - this is much more efficient
                    api.applyTransaction({ add: newBatch, addIndex: undefined });

                    // Also update state for consistency (but this won't cause re-render of all rows)
                    setRowData((prev) => [...prev, ...newBatch]);
                  } else {
                    // Fallback if API not ready yet
                    setRowData((prev) => [...prev, ...newBatch]);
                  }
                }
              } catch (err) {
                console.error("Error parsing batch event:", err);
              }
            }
          }
        }

        api.hideOverlay();
        setIsFetching(false);
        setIsDataLoadingComplete(true);
      } catch (err) {
        console.error("Error fetching TMM data:", err);
        setRowData([]);
        api.showNoRowsOverlay();
        hasFetchedData.current = false; // Allow retry on error
        setIsFetching(false);
        setIsDataLoadingComplete(true);
      }
    };



    fetchData();



    setShowPopup(true);

    window.startTmmLiveData = () => {
      setShowPopup(false);

      api.hideOverlay();
    };

    return () => {
      delete (window as any).startTmmLiveData;
    };
  }, [dataofrls, hasFetchedData, gridApi]);


  window.startTmmLiveData = () => {
    setShowPopup(false);
    const api = gridApiRef.current;

    api.hideOverlay();
  };


  const exportFilteredRows = () => {
    setIsDownloading(true);

    if (!gridApi) return;

    // Immediately flip the button text to "Exporting..."

    // Kick the heavy export work to the next event loop tick so the UI
    // can paint the updated button state before the CSV generation runs.
    setTimeout(() => {
      try {
        gridApi.exportDataAsCsv({
          processCellCallback: (params: any) => {
            const colId = params.column.getColId();
            const raw = params.value;

            // Treat ISBN-like columns as text in Excel
            if (["EAN", "ISBN_9", "ISBN_10", "ISBN", "PARENT_ISBN", "EBOOK_ISBN","COMPETITIVE_TITLES", "COMPARATIVE_TITLES"].includes(colId)) {
              return raw != null ? "\t" + raw : "";
            }

            // Format LTD Gross / Return / Net as USD currency in export
            if (
              colId === "LTD_Gross" ||
              colId === "LTD_Return" ||
              colId === "LTD_Net"
            ) {
              if (raw === null || raw === undefined || raw === "") return "";
              const num = Number(raw);
              if (isNaN(num)) return String(raw);
              return num.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
            }

            // Format Sell Through as percentage with % sign in export
            if (colId === "Sell_Through_Pct") {
              if (raw === null || raw === undefined || raw === "") return "";
              const num = Number(raw);
              if (isNaN(num)) return String(raw);
              const pct = num * 100;
              return `${pct.toFixed(2)}%`;
            }

            // Paper Cut Off: date only (no time) in export
            if (colId === "PAPER_CUT_OFF") {
              if (raw === null || raw === undefined || raw === "") return "";
              const d = new Date(raw);
              if (isNaN(d.getTime())) return String(raw);
              return d.toLocaleDateString("en-US");
            }

            // LDC: date only (no time) in export
            if (colId === "LDC") {
              if (raw === null || raw === undefined || raw === "") return "";
              const d = new Date(raw);
              if (isNaN(d.getTime())) return String(raw);
              return d.toLocaleDateString("en-US");
            }

            return raw;
          },
          onlySelected: false,
          // Export only currently visible columns so hidden ones are not included
          allColumns: false,
          onlyFiltered: true,
          fileName: "TMM_EXPORT.csv",
        });
      } finally {
        // Keep "Exporting..." visible briefly so the user clearly sees it,
        // even if the browser download finishes very quickly.
        setTimeout(() => setIsDownloading(false), 1500);
      }
    }, 0);
  };
  const fetchAllPageData = () => {
    if (value[0] == "0") return
    const seasonData = watch("season");

    const division = watch("division");

    const feildIsbns = Array.isArray(watch("isbn"))
      ? watch("isbn").map((data) => data.value)
      : [];

    const authors = Array.isArray(watch("author"))
      ? watch("author").map((data) => data.label)
      : [];

    const imprint = watch("imprint");

    const managingEditors = watch("managingEditor");
    const bisacStatus = watch("bisac_status");
    const editors = watch("editor");
    const format = watch("format");

    handleTitleListRecordsFilterFetch();
    dispatch(
      FetchbisacStatus({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        flag: true,
        column: column,
        value: value
      })
    );

    dispatch(
      FetchEditor({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        flag: true,
        column: column,
        value: value
      })
    );
    dispatch(
      FetchManagingEditor({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        flag: true,
        column: column,
        value: value
      })
    );

    dispatch(
      fetchDivision({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        flag: true,
        column: column,
        value: value
      })
    );
    dispatch(
      FetchSeason({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        flag: true,
        column: column,
        value: value
      })
    );
    dispatch(
      fetchImprint({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        flag: true,
        column: column,
        value: value
      })
    );
    dispatch(
      fetchFormat({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        flag: true,
        column: column,
        value: value
      })
    );
    fetchAuthors();
    commonFetchIsbns();
  };
  useEffect(() => {
    if (seasonReducer.selectedSeasonList?.length) {
      setValue("season", seasonReducer.selectedSeasonList);
    }
    if (divisionReducer.selectedDivisionList?.length) {
      setValue("division", divisionReducer.selectedDivisionList);
    }
    if (imprintReducer.selectedImprintList?.length) {
      setValue("imprint", imprintReducer.selectedImprintList);
    }

    if (formatReducer.selectedFormatList?.length) {
      setValue("format", formatReducer.selectedFormatList);
    }
    if (isbnReducer.selectedISBNSList?.length) {
      setValue("isbn", isbnReducer.selectedISBNSList);
    }

    if (isbnReducer.selectedTitlesList?.length) {
      setValue("title", isbnReducer.selectedTitlesList);
    }
    if (selectedManagingEditors?.length) {
      setValue("managingEditor", selectedManagingEditors);
    }
    if (selectedEditors?.length) {
      setValue("editor", selectedEditors);
    }
    if (selectedBisacStatus?.length) {
      setValue("bisac_status", selectedBisacStatus);
    }
    dispatch(emptyDetailsPageRecord());
    if (
      value[0] !== "0" &&
      !seasonReducer.data?.length ||
      !TitleListReducer.data?.length ||
      !isbnReducer.isbns?.length ||
      !authorReducer.data?.length ||
      !divisionReducer.data?.length ||
      !imprintReducer.data?.length ||
      !managingEditorReducer.data?.length ||
      !editorReducer.data?.length ||
      !bisanStatusReducer.data?.length
    )
      fetchAllPageData();
    return () => {
      dispatch(resetTitleListPage());
      dispatch(resetIsbnPage());
    };
  }, [dataofrls]);
  useEffect(() => {
    const isAllTopFiltersEmpty =
      !(seasonReducer.selectedSeasonList?.length ?? 0) &&
      !(divisionReducer.selectedDivisionList?.length ?? 0) &&
      !(imprintReducer.selectedImprintList?.length ?? 0) &&
      !(formatReducer.selectedFormatList?.length ?? 0) &&
      !(isbnReducer.selectedISBNSList?.length ?? 0) &&
      !(isbnReducer.selectedTitlesList?.length ?? 0) &&
      !(selectedManagingEditors?.length ?? 0) &&
      !(selectedEditors?.length ?? 0) &&
      !(selectedBisacStatus?.length ?? 0) &&
      !(authorReducer.Author1?.length ?? 0);

    // Button should be enabled if either top filters OR grid column filters have values
    const hasAnyFilters = !isAllTopFiltersEmpty || hasGridColumnFilters;
    setButtonDisabled(!hasAnyFilters);
  }, [
    seasonReducer.selectedSeasonList,
    divisionReducer.selectedDivisionList,
    imprintReducer.selectedImprintList,
    formatReducer.selectedFormatList,
    isbnReducer.selectedISBNSList,
    isbnReducer.selectedTitlesList,
    selectedManagingEditors,
    selectedEditors,
    selectedBisacStatus,
    authorReducer.Author1,
    hasGridColumnFilters,
  ]);
  useEffect(() => {
    if (value[0] !== "0") {


      fetchAllPageData();
    }

  }, [
    watch("season"),
    watch("division"),
    watch("imprint"),
    watch("isbn"),
    watch("title"),
    watch("author"),
    watch("bisac_status"),
    watch("editor"),
    watch("managingEditor"),
    watch("format"),
  ]);

  useEffect(() => {
    if (
      authorReducer.fetchType?.length &&
      authorReducer.fetchType === "fetchAll"
      && value[0] !== "0"
    ) {
      setValue("author", authorOptions);
      dispatch(UpdateAuthor1List(authorOptions));
      dispatch(UpdateAuthor1(authorOptions));
      dispatch(removeAuthorFetchType());
      dispatch(setAuthorString(""));
      fetchAllPageData();
    }
  }, [authorReducer.fetchType]);

  const fetchAuthors = (fetchType?: string) => {
    const seasonData = watch("season");

    const division = watch("division");

    const feildIsbns = Array.isArray(watch("isbn"))
      ? watch("isbn").map((data) => data.value)
      : [];

    const authors = Array.isArray(watch("author"))
      ? watch("author").map((data) => data.label)
      : [];

    const imprint = watch("imprint");

    const managingEditors = watch("managingEditor");
    const bisacStatus = watch("bisac_status");
    const editors = watch("editor");
    const format = watch("format");

    dispatch(
      FetchAuthor1({
        fetchType: fetchType,
        searchStr: authorReducer.authorString,
        seasons: seasonData,
        oldEans: isbnReducer.isbns.map((isbn) => isbn._id),
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        divisions: division,
        isbns: watch("isbn")?.length
          ? watch("isbn").map((isbn) => isbn.value)
          : [],
        imprint: imprint,
        limit: authorReducer.limit,
        page: authorReducer.page,
        selectedData: watch("author")?.length
          ? watch("author").map((author) => author.label)
          : [],
        prevSeason: seasonReducer.selectedSeason,
        prevDivision: divisionReducer.selectedDivision,
        prevImprint: imprintReducer.selectedImprint,
        prevFormat: formatReducer.selectedFormat,
        prevIsbns: isbnReducer.selectedISBNS,
        prevManagingEditors: selectedManagingEditors,
        prevEditors: selectedEditors,
        prevBisacStatus: selectedBisacStatus,
        prevAuthor: authorReducer.Author1,
        flag: true,
        column: column,
        value: value
      })
    );
  };
  useEffect(() => {
    if (authorReducer.page > 1 || authorReducer.authorString?.length) {
      fetchAuthors();
    }
  }, [authorReducer.page, authorReducer.authorString]);
  useEffect(() => {
    if (value[0] !== "0") {
      commonFetchIsbns();
    }
  }, [isbnReducer.isbnPage, isbnReducer.isbnsString]);
  const commonFetchIsbns = (type?: string) => {
    const seasonData = watch("season");

    const division = watch("division");

    const feildIsbns = Array.isArray(watch("isbn"))
      ? watch("isbn").map((data) => data.value)
      : [];

    const authors = Array.isArray(watch("author"))
      ? watch("author").map((data) => data.label)
      : [];

    const imprint = watch("imprint");

    const managingEditors = watch("managingEditor");
    const bisacStatus = watch("bisac_status");
    const editors = watch("editor");
    const format = watch("format");

    dispatch(
      fetchIsbnList({
        fetchType: type,
        seasons: seasonData,
        isbnString: isbnReducer.isbnsString,
        oldEans: isbnReducer.isbns.map((isbn) => isbn._id),
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        divisions: division,
        isbns: isbnReducer.isbns,
        imprint: imprint,
        format: format,
        limit: isbnReducer.isbnLimit,
        page: isbnReducer.isbnPage,
        selectedData: watch("isbn")?.length
          ? watch("isbn").map((isbn) => isbn.value)
          : [],
        prevSeason: seasonReducer.selectedSeason,
        prevDivision: divisionReducer.selectedDivision,
        prevImprint: imprintReducer.selectedImprint,
        prevFormat: formatReducer.selectedFormat,
        prevIsbns: isbnReducer.selectedISBNS,
        prevManagingEditors: selectedManagingEditors,
        prevEditors: selectedEditors,
        prevBisacStatus: selectedBisacStatus,
        prevAuthor: authorReducer.Author1,
        flag: true,
        column: column,
        value: value
      })
    );
  };
  const handleSelectAllIsbn = () => {
    setOnMultiSearchSelect(false);

    if (isbnReducer.isbnsString?.length > 0) {
      dispatch(resetIsbnPage());
      commonFetchIsbns("fetchAll");
    }
  };

  const handleSelectAllAuthors = () => {
    setOnMultiSearchSelect(false);

    if (authorReducer.authorString?.length > 0) {
      dispatch(resetAuthorPage());
      commonFetchIsbns("fetchAll");
    }
  };

  // Add this new function inside your component
  const clearAllFilters = () => {
    // Set flag to prevent grid sync from restoring values during clear
    isClearingFiltersRef.current = true;

    // Clear grid column filters
    if (gridApi) {
      gridApi.setFilterModel(null); // Clears all grid column filters
      gridApi.onFilterChanged(); // Refresh grid after clearing
    }
    setHasGridColumnFilters(false); // Reset grid filter state

    // Clear top filter dropdowns form values - use shouldValidate and shouldDirty to ensure UI updates
    setValue("season", [], { shouldValidate: true, shouldDirty: true });
    setValue("division", [], { shouldValidate: true, shouldDirty: true });
    setValue("imprint", [], { shouldValidate: true, shouldDirty: true });
    setValue("isbn", [], { shouldValidate: true, shouldDirty: true });
    setValue("title", [], { shouldValidate: true, shouldDirty: true });
    setValue("managingEditor", [], { shouldValidate: true, shouldDirty: true });
    setValue("editor", [], { shouldValidate: true, shouldDirty: true });
    setValue("format", [], { shouldValidate: true, shouldDirty: true });
    setValue("bisac_status", [], { shouldValidate: true, shouldDirty: true });
    setValue("author", [], { shouldValidate: true, shouldDirty: true });

    // Clear Redux state for all filters
    dispatch(UpdateSelectedISBNS([]));
    dispatch(UpdateSelectedISBNSList([]));
    dispatch(UpdateSelectedTitles([]));
    dispatch(UpdateSelectedTitlesList([]));
    dispatch(setIsbnNumberOptions([]));
    dispatch(setIsbnTitleOptions([]));
    dispatch(setIsbnString("")); // Clear ISBN search string
    dispatch(resetIsbnPage()); // Reset ISBN page
    dispatch(UpdateSelectedSeason([]));
    dispatch(UpdateSelectedSeasonList([]));
    dispatch(UpdateSelectedDivision([]));
    dispatch(UpdateSelectedDivisionList([]));
    dispatch(UpdateSelectedImprint([]));
    dispatch(UpdateSelectedImprintList([]));
    dispatch(UpdateSelectedFormat([]));
    dispatch(UpdateSelectedFormatList([]));
    dispatch(UpdateAuthor1([]));
    dispatch(UpdateAuthor1List([]));
    dispatch(UpdatebisacStatus([]));
    dispatch(UpdatebisacStatusList([]));
    dispatch(UpdateEditor([]));
    dispatch(UpdateEditorList([]));
    dispatch(UpdatemanagingEditor([]));
    dispatch(UpdatemanagingEditorList([]));
    const TitleListIds = TitleListReducer.data.map((data) => data._id);

    // Use empty arrays for prev values since we're clearing everything
    dispatch(
      FetchTitleListRecord({
        page: TitleListReducer.page,
        limit: TitleListReducer.limit,
        season: [],
        Division: [],
        Imprint: [],
        Format: [],
        TitleListIds: TitleListIds,
        managingEditor: [],
        editors: [],
        bisacStatus: [],
        author: [],
        isbns: [],
        prevSeason: [],
        prevDivision: [],
        prevImprint: [],
        prevFormat: [],
        prevIsbns: [],
        prevManagingEditors: [],
        prevEditors: [],
        prevBisacStatus: [],
        prevAuthor: [],
        flag: true,
        column: column,
        value: value
      })
    );

    // Reset flag after a delay to allow all operations to complete using Promise
    delay(50).then(() => {
      isClearingFiltersRef.current = false;
    });
  };

  useEffect(() => {
    // When the sidebar navigation decides filters should be reset (e.g. when
    // moving between Title Search, TMM Export, and Inventory Report), respond
    // to the shared flag by clearing local filters and then turning the flag off.
    if (resetFiltersInexport) {
      clearAllFilters();
      dispatch(setresetFiltersInexport(false));
    }
  }, [resetFiltersInexport]);
  const authorOptions: OptionType[] = authorReducer.data
    .map((author: any) =>
      author.AUTHOR_1?.length > 1
        ? {
          value: author._id ?? "",
          label: author.AUTHOR_1 ?? "",
        }
        : undefined
    )
    .filter((option): option is OptionType => option !== undefined);

  const isbn_number_options = isbnReducer.isbns.map((isbn: any) => ({
    value: isbn._id ?? "",
    label: isbn.ISBN ?? "",
  }));
  const customFilterOption = (
    candidate: { label: string; value: string },
    input: string
  ): boolean => {
    // Ensure input is case insensitive and check if it starts with the input
    const inputValue = input.toLowerCase();
    const candidateLabel = candidate.label.toLowerCase();
    return candidateLabel.includes(inputValue);
  };
  const debounceIsbnsSearchStr = debounceAsync(
    async (searchStr) => dispatch(setIsbnString(searchStr)),
    300
  );
  const debounceUpdateAuthorString = debounceAsync(
    async (searchStr) => dispatch(setAuthorString(searchStr)),
    300
  );
  useEffect(() => {
    if (authorReducer.page > 1 || authorReducer.authorString?.length) {
      fetchAuthors();
    }
  }, [authorReducer.page, authorReducer.authorString]);
  const isbn_title_options = isbnReducer.isbns
    .map((isbn: any) => {
      if (isbn.FULL_TITLE?.length > 1) {
        return {
          value: isbn._id ?? "",
          label: isbn.FULL_TITLE ?? "",
        };
      }
      return undefined;
    })
    .filter((option): option is OptionType => option !== undefined);

  const numberOptions = isbnReducer.numberOptions;

  const titleOptions = isbnReducer.titleOptions;



  useEffect(() => {
    if (isbnReducer.isbns?.length) {
      dispatch(setIsbnNumberOptions(isbn_number_options));

      dispatch(setIsbnTitleOptions(isbn_title_options));
    }
  }, [isbnReducer.isbns]);

  useEffect(() => {
    if (isbnReducer.fetchType?.length && isbnReducer.fetchType === "fetchAll") {
      setValue("isbn", isbn_number_options);
      setValue("title", isbn_title_options);
      dispatch(UpdateSelectedISBNSList(isbn_number_options));
      dispatch(UpdateSelectedTitlesList(isbn_title_options));
      dispatch(UpdateSelectedISBNS(isbn_number_options));
      dispatch(UpdateSelectedTitles(isbn_title_options));
      dispatch(setIsbnString(""));
    }
  }, [isbnReducer.fetchType]);
  const handleTitleListRecordsFilterFetch = () => {
    const seasonData = watch("season");
    const division = watch("division");
    const isbns = watch("isbn");
    const imprint = watch("imprint");
    const format = watch("format");
    const TitleListIds = TitleListReducer.data.map((data) => data._id);

    const authors = Array.isArray(watch("author"))
      ? watch("author").map((data) => data.label)
      : [];

    dispatch(UpdateSelectedISBNS(isbns));
    dispatch(UpdateSelectedTitles(watch("title")));
    dispatch(UpdateAuthor1(authors));
    dispatch(UpdatebisacStatus(watch("bisac_status")));
    dispatch(UpdateEditor(watch("editor")));
    dispatch(UpdatemanagingEditor(watch("managingEditor")));
    dispatch(UpdateSelectedSeason(seasonData));
    dispatch(UpdateSelectedDivision(division));
    dispatch(UpdateSelectedImprint(imprint));
    dispatch(UpdateSelectedFormat(format));

    dispatch(UpdateSelectedISBNSList(watch("isbn")));
    dispatch(UpdateAuthor1List(watch("author")));
    dispatch(UpdatebisacStatusList(watch("bisac_status")));
    dispatch(UpdateEditorList(watch("editor")));
    dispatch(UpdatemanagingEditorList(watch("managingEditor")));
    dispatch(UpdateSelectedTitlesList(watch("title")));
    dispatch(UpdateSelectedSeasonList(watch("season")));
    dispatch(UpdateSelectedDivisionList(watch("division")));
    dispatch(UpdateSelectedImprintList(watch("imprint")));
    dispatch(UpdateSelectedFormatList(watch("format")));
  };
  useEffect(() => {
    handleTitleListRecordsFilterFetch();
  }, [TitleListReducer.page, TitleListReducer.titleSortBy]);

  // Track if initial filters have been applied to prevent infinite loops
  const initialFiltersAppliedRef = useRef<boolean>(false);

  // Apply queued filters once data loading is complete (grid column filters are always enabled)
  useEffect(() => {
    // CRITICAL: Prevent infinite loops by checking if filters are already applied
    // Only run once when data is first loaded, not on every state change
    if (isDataLoadingComplete && gridApi && !isFetching && rowData.length > 0 && columnDefs.length > 0 && !filtersEnabledRef.current && !initialFiltersAppliedRef.current) {
      // Grid column filters are always enabled - no need to enable them
      filtersEnabledRef.current = true;
      initialFiltersAppliedRef.current = true; // Mark as applied to prevent re-running

      // Wait a bit for grid to fully render all rows and enable filters using Promise
      const filterPromise = delay(1000).then(() => {
        // Apply all pending filters (only ISBN and other filters, no title filters)
        pendingFiltersRef.current.forEach((pendingFilter) => {
          if (pendingFilter.type === 'isbn') {
            applyIsbnFilterToGrid(pendingFilter.values);
          } else if (pendingFilter.type === 'title') {
            // Skip title filters - grid only filters by ISBN
            // Title selection is only used to determine which ISBNs to filter
          } else if (pendingFilter.type === 'other' && pendingFilter.field) {
            applyFilterToGrid(pendingFilter.values, pendingFilter.field);
          }
        });

        // Clear the queue
        pendingFiltersRef.current = [];

        // CRITICAL: Don't apply current selections here - this causes infinite loops
        // The filters are already applied by changeIsbnInfo when user selects
        // Applying them here again causes: apply filter -> onFilterChanged -> grid sync -> setValue -> re-render -> apply filter again
        // Only apply pending filters that were queued before data loaded
      });

      // No cleanup needed for promises - they complete naturally
    }

    // Reset initialFiltersAppliedRef when data is cleared or fetching starts
    if (isFetching || rowData.length === 0) {
      initialFiltersAppliedRef.current = false;
    }
  }, [isDataLoadingComplete, gridApi, isFetching, rowData.length]);
  //   const changeIsbnInfo = (event: any) => {
  //     if (!event.target.value?.length) {
  //     dispatch(setIsbnNumberOptions([]));
  //     dispatch(setIsbnTitleOptions([]));
  //     }
  //     if (event.target.name === "title") {
  //       const titleIsbns = watch("title").map((title: any) => title.value);
  //       const isbnFilteredData =
  //       numberOptions?.filter((isbn) => titleIsbns.includes(isbn.value)) || [];
  //       const uniqueIsbns = Array.from(
  //         new Map(isbnFilteredData.map((item) => [item.value, item])).values()
  //       );
  //       // keep form values in sync: selecting titles should set matching ISBNs
  //       setValue("isbn", uniqueIsbns);
  //       // Also update grid filters to reflect the ISBN selection
  //       handleIsbnFilterChange(uniqueIsbns);
  //       console.log("uniqueIsbns", uniqueIsbns);
  //     } else if (event.target.name === "isbn") {
  //       const isbnsList = watch("isbn").map((isbn: any) => isbn.value);

  //       const titleFilteredData =
  //       titleOptions?.filter((title) => isbnsList.includes(title.value)) || [];
  //       const uniqueTitles = Array.from(
  //         new Map(titleFilteredData.map((item) => [item.value, item])).values()
  //       );
  //       // selecting ISBN(s) should set the matching title(s)
  //       setValue("title", uniqueTitles);
  //       // Also update grid filters to reflect the title selection
  //       handleTitleFilterChange(uniqueTitles);
  //       console.log("uniqueTitles", uniqueTitles);

  //   }
  // };
  const changeIsbnInfo = (eventOrValue: any) => {
    const isDomEvent = !!(eventOrValue && eventOrValue.target && eventOrValue.target.name);

    let name: string;
    let value: any;

    if (isDomEvent) {
      name = eventOrValue.target.name;
      value = eventOrValue.target.value;
    } else if (eventOrValue && eventOrValue._rs_name) {
      name = eventOrValue._rs_name;
      value = eventOrValue._rs_value;
    } else {
      name = "title";
      value = eventOrValue;
    }

    const isEmpty =
      value == null ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === "string" && value.trim().length === 0);

    if (isEmpty) {
      // Set flag to prevent grid sync from restoring values during clear
      isClearingFiltersRef.current = true;

      setValue("isbn", [], { shouldValidate: true, shouldDirty: true });
      setValue("title", [], { shouldValidate: true, shouldDirty: true });
      dispatch(setIsbnNumberOptions([]));
      dispatch(setIsbnTitleOptions([]));
      dispatch(UpdateSelectedISBNSList([]));
      dispatch(UpdateSelectedTitlesList([]));
      dispatch(UpdateSelectedISBNS([]));
      dispatch(UpdateSelectedTitles([]));

      // Clear grid filters for both ISBN and title when clearing
      if (gridApi) {
        const filterModel = gridApi.getFilterModel() || {};
        delete filterModel['EAN'];
        delete filterModel['ISBN'];
        delete filterModel['ISBN_9'];
        delete filterModel['ISBN_10'];
        delete filterModel['PARENT_ISBN'];
        delete filterModel['FULL_TITLE'];
        gridApi.setFilterModel(filterModel);
        gridApi.onFilterChanged();
        setHasGridColumnFilters(Object.keys(filterModel).length > 0);
      }

      // Reset flag after a short delay to allow operations to complete
      delay(50).then(() => {
        isClearingFiltersRef.current = false;
      });

      return;
    }
    if (name === "title") {
      const titleIsbns = Array.isArray(value) ? value.map((t) => t.value) : [];

      // If title list is empty, clear both ISBN and title
      if (!titleIsbns || titleIsbns.length === 0) {
        // Set flag to prevent grid sync from restoring values during clear
        isClearingFiltersRef.current = true;

        setValue("isbn", [], { shouldValidate: true, shouldDirty: true });
        setValue("title", [], { shouldValidate: true, shouldDirty: true });
        dispatch(UpdateSelectedISBNSList([]));
        dispatch(UpdateSelectedTitlesList([]));
        dispatch(UpdateSelectedISBNS([]));
        dispatch(UpdateSelectedTitles([]));

        // Clear grid filters for both ISBN and title
        if (gridApi) {
          const filterModel = gridApi.getFilterModel() || {};
          delete filterModel['EAN'];
          delete filterModel['ISBN'];
          delete filterModel['ISBN_9'];
          delete filterModel['ISBN_10'];
          delete filterModel['PARENT_ISBN'];
          delete filterModel['FULL_TITLE'];
          gridApi.setFilterModel(filterModel);
          gridApi.onFilterChanged();
          setHasGridColumnFilters(Object.keys(filterModel).length > 0);
        }

        // Reset flag after a short delay using Promise
        delay(50).then(() => {
          isClearingFiltersRef.current = false;
        });

        return;
      }

      // Get current ISBNs and identify non-title ISBNs
      const currentIsbns = watch("isbn") || [];

      // Get all ISBN values that have titles (from titleOptions)
      const allTitleIsbnValues = new Set(
        (titleOptions || []).map((title: any) => String(title.value))
      );

      // Identify non-title ISBNs: ISBNs that don't have titles in titleOptions
      // These are ISBNs that were selected without titles and should be preserved
      const nonTitleIsbns = currentIsbns.filter((isbn: any) =>
        isbn && isbn.value && !allTitleIsbnValues.has(String(isbn.value))
      );

      // OPTIMIZATION: Find ISBNs that match the currently selected titles using Sets and Maps for O(1) lookups
      // titleIsbns contains the ISBN _ids from selected titles
      const titleIsbnSet = new Set<string>();
      for (let i = 0; i < titleIsbns.length; i++) {
        titleIsbnSet.add(String(titleIsbns[i]));
      }

      const titleMatchingIsbnsMap = new Map<string, any>();

      // First pass: find matching ISBNs in numberOptions
      if (numberOptions && numberOptions.length > 0) {
        for (let i = 0; i < numberOptions.length; i++) {
          const isbn = numberOptions[i];
          if (isbn && isbn.value && titleIsbnSet.has(String(isbn.value))) {
            titleMatchingIsbnsMap.set(String(isbn.value), isbn);
          }
        }
      }

      // Second pass: find missing ISBNs in currentIsbns
      if (titleMatchingIsbnsMap.size < titleIsbns.length) {
        const currentIsbnsMap = new Map<string, any>();
        for (let i = 0; i < currentIsbns.length; i++) {
          const isbn = currentIsbns[i];
          if (isbn && isbn.value) {
            currentIsbnsMap.set(String(isbn.value), isbn);
          }
        }

        for (let i = 0; i < titleIsbns.length; i++) {
          const tid = String(titleIsbns[i]);
          if (!titleMatchingIsbnsMap.has(tid) && currentIsbnsMap.has(tid)) {
            titleMatchingIsbnsMap.set(tid, currentIsbnsMap.get(tid));
          }
        }
      }

      // Third pass: find missing ISBNs in isbnReducer.isbns
      if (titleMatchingIsbnsMap.size < titleIsbns.length) {
        const isbnReducerMap = new Map<string, any>();
        if (isbnReducer.isbns && isbnReducer.isbns.length > 0) {
          for (let i = 0; i < isbnReducer.isbns.length; i++) {
            const isbn = isbnReducer.isbns[i];
            if (isbn && isbn._id) {
              isbnReducerMap.set(String(isbn._id), isbn);
            }
          }
        }

        for (let i = 0; i < titleIsbns.length; i++) {
          const missingId = String(titleIsbns[i]);
          if (!titleMatchingIsbnsMap.has(missingId)) {
            const foundIsbn = isbnReducerMap.get(missingId);
            if (foundIsbn) {
              titleMatchingIsbnsMap.set(missingId, {
                value: foundIsbn._id || missingId,
                label: foundIsbn.ISBN || (foundIsbn as any).EAN || missingId,
              });
            } else {
              // Final fallback: use the _id as both value and label
              titleMatchingIsbnsMap.set(missingId, {
                value: missingId,
                label: missingId,
              });
            }
          }
        }
      }

      const titleMatchingIsbns = Array.from(titleMatchingIsbnsMap.values());

      // OPTIMIZATION: Build the final ISBN list using Maps for O(1) lookups
      // 1. Include ISBNs that match current titles
      // 2. Include non-title ISBNs (preserve ISBNs without titles)
      const isbnMap = new Map<string, any>();

      // Create a Map from titleMatchingIsbns for O(1) lookup
      const titleMatchingIsbnsLookupMap = new Map<string, any>();
      for (let i = 0; i < titleMatchingIsbns.length; i++) {
        const isbn = titleMatchingIsbns[i];
        if (isbn && isbn.value) {
          titleMatchingIsbnsLookupMap.set(String(isbn.value), isbn);
        }
      }

      // Create a Map from currentIsbns for O(1) lookup
      const currentIsbnsMap = new Map<string, any>();
      for (let i = 0; i < currentIsbns.length; i++) {
        const isbn = currentIsbns[i];
        if (isbn && isbn.value) {
          currentIsbnsMap.set(String(isbn.value), isbn);
        }
      }

      // Add ISBNs that match current titles - ensure ALL title ISBNs are included
      for (let i = 0; i < titleIsbns.length; i++) {
        const titleIsbnId = String(titleIsbns[i]);
        // Find the matching ISBN in titleMatchingIsbnsLookupMap
        const matchingIsbn = titleMatchingIsbnsLookupMap.get(titleIsbnId);
        if (matchingIsbn) {
          isbnMap.set(titleIsbnId, matchingIsbn);
        } else {
          // If not found, try to get it from currentIsbnsMap
          const foundInCurrent = currentIsbnsMap.get(titleIsbnId);
          if (foundInCurrent) {
            isbnMap.set(titleIsbnId, foundInCurrent);
          }
        }
      }

      // Add non-title ISBNs (preserve ISBNs that don't have titles)
      for (let i = 0; i < nonTitleIsbns.length; i++) {
        const isbn = nonTitleIsbns[i];
        if (isbn && isbn.value) {
          const key = String(isbn.value);
          isbnMap.set(key, isbn);
        }
      }

      const mergedIsbns = Array.from(isbnMap.values());

      // Preserve the selected titles in form state
      const selectedTitles = Array.isArray(value) ? value : [];

      // OPTIMIZATION: Set flag FIRST to prevent grid sync from interfering
      // This must happen before any filter operations
      isSelectingIsbnsRef.current = true;

      // Calculate filter conditions before any state updates
      const allIsbnsHaveTitles = mergedIsbns.length > 0 &&
        mergedIsbns.every((isbn: any) =>
          titleIsbns.includes(String(isbn.value))
        );

      // CRITICAL: Apply filters FIRST before any state updates
      // This prevents the grid from showing all ISBNs first, then filtering
      if (gridApi) {
        // Get current filter model
        const filterModel = gridApi.getFilterModel() || {};

        // Extract ISBN numbers for filtering
        const numberOptionsMap = new Map<string, any>();
        if (numberOptions && numberOptions.length > 0) {
          for (let i = 0; i < numberOptions.length; i++) {
            const opt = numberOptions[i];
            if (opt && opt.value) {
              numberOptionsMap.set(String(opt.value), opt);
            }
          }
        }

        const isbnNumbers: string[] = [];
        const seenIsbns = new Set<string>();

        for (let i = 0; i < mergedIsbns.length; i++) {
          const item = mergedIsbns[i];
          if (!item) continue;

          let extractedIsbn: string | null = null;

          if (typeof item === 'string') {
            const trimmed = item.trim();
            if (trimmed.length >= 10) {
              extractedIsbn = trimmed;
            }
          } else if (typeof item === 'object') {
            // Prefer label (actual ISBN number)
            if (item.label) {
              const labelStr = String(item.label).trim();
              if (labelStr.length >= 10) {
                extractedIsbn = labelStr;
              }
            }

            // If no label, try to find it from numberOptionsMap using value (_id)
            if (!extractedIsbn && item.value && numberOptionsMap.size > 0) {
              const foundIsbn = numberOptionsMap.get(String(item.value));
              if (foundIsbn && foundIsbn.label) {
                const foundLabel = String(foundIsbn.label).trim();
                if (foundLabel.length >= 10) {
                  extractedIsbn = foundLabel;
                }
              }
            }

            // Fallback to value if it looks like an ISBN
            if (!extractedIsbn && item.value) {
              const valueStr = String(item.value).trim();
              if (/^(978|979)?\d{10,13}$/.test(valueStr) || (valueStr.length >= 10 && /^\d+$/.test(valueStr))) {
                extractedIsbn = valueStr;
              }
            }
          }

          if (extractedIsbn && !seenIsbns.has(extractedIsbn)) {
            isbnNumbers.push(extractedIsbn);
            seenIsbns.add(extractedIsbn);
          }
        }

        // CRITICAL: Only apply ISBN filter - DO NOT use title filter in grid
        // Title selection is only used to determine which ISBNs to filter
        // The grid itself only filters by ISBN, not by title
        if (isbnNumbers.length > 0) {
          filterModel['EAN'] = {
            filterType: 'text',
            operator: 'OR',
            conditions: isbnNumbers.map(val => ({
              filterType: 'text',
              type: 'equals',
              filter: val
            }))
          };
        } else {
          delete filterModel['EAN'];
        }

        // Always remove title filter from grid - we only filter by ISBN
        delete filterModel['FULL_TITLE'];

        // CRITICAL: Apply BOTH filters in a single atomic operation
        // This prevents the grid from showing intermediate states
        gridApi.setFilterModel(filterModel);
        // Don't call onFilterChanged here - let it be called naturally by the grid
        // or call it once after a microtask to ensure both filters are applied
        delay(0).then(() => {
          if (gridApi) {
            gridApi.onFilterChanged();
          }
        });
      }

      // CRITICAL: Update form state ONCE with final values
      // Use startTransition to batch all React updates together and prevent intermediate renders
      // This ensures React Select doesn't see intermediate states (add -> remove -> add)
      startTransition(() => {
        // Update form state with final values - this is the ONLY place we update it
        // This prevents the flickering in the top filter dropdown
        setValue("isbn", mergedIsbns, { shouldValidate: true, shouldDirty: true });
        setValue("title", selectedTitles, { shouldValidate: true, shouldDirty: true });

        // Update Redux state to persist selections
        dispatch(UpdateSelectedISBNSList(mergedIsbns));
        dispatch(UpdateSelectedTitlesList(selectedTitles));
        dispatch(UpdateSelectedISBNS(mergedIsbns));
        dispatch(UpdateSelectedTitles(selectedTitles));
      });

      // Reset flag after operations complete using Promise
      // Use a small delay to ensure all state updates are processed
      delay(100).then(() => {
        isSelectingIsbnsRef.current = false;
        lastTitleSelectionRef.current = "";
      });
    }

    else if (name === "isbn") {
      const isbnsList = Array.isArray(value) ? value.map((i) => i.value) : [];

      // If ISBN list is empty, clear both ISBN and title
      if (!isbnsList || isbnsList.length === 0) {
        // Set flag to prevent grid sync from restoring values during clear
        isClearingFiltersRef.current = true;

        setValue("isbn", [], { shouldValidate: true, shouldDirty: true });
        setValue("title", [], { shouldValidate: true, shouldDirty: true });
        dispatch(UpdateSelectedISBNSList([]));
        dispatch(UpdateSelectedTitlesList([]));
        dispatch(UpdateSelectedISBNS([]));
        dispatch(UpdateSelectedTitles([]));

        // Clear grid filters for both ISBN and title
        if (gridApi) {
          const filterModel = gridApi.getFilterModel() || {};
          delete filterModel['EAN'];
          delete filterModel['ISBN'];
          delete filterModel['ISBN_9'];
          delete filterModel['ISBN_10'];
          delete filterModel['PARENT_ISBN'];
          delete filterModel['FULL_TITLE'];
          gridApi.setFilterModel(filterModel);
          gridApi.onFilterChanged();
          setHasGridColumnFilters(Object.keys(filterModel).length > 0);
        }

        // Reset flag after a short delay using Promise
        delay(50).then(() => {
          isClearingFiltersRef.current = false;
        });

        return;
      }

      // IMPORTANT: Always keep ISBNs selected, even if they have no matching titles
      // Some ISBNs may not have titles, so ISBNs should remain selected regardless

      // Set flag to prevent grid sync from removing ISBNs during selection
      isSelectingIsbnsRef.current = true;

      // Find titles that match the selected ISBNs (only if titles exist for those ISBNs)
      const matchedTitles =
        titleOptions?.filter((title) => isbnsList.includes(title.value)) || [];

      // Get current titles that are still valid (match selected ISBNs)
      const currentTitles = watch("title") || [];
      const validCurrentTitles = currentTitles.filter((ct) =>
        isbnsList.some((i) => i === ct.value)
      );

      // Merge matched titles with valid current titles, properly deduplicating by ISBN value
      // Each ISBN should have only one title entry (title.value = ISBN _id)
      // Use a Map with ISBN value as key to ensure uniqueness
      const titleMapByIsbn = new Map<string, OptionType>();

      // Add matched titles first - deduplicate by ISBN value (title.value)
      matchedTitles.forEach((title) => {
        if (title && title.value) {
          const isbnKey = String(title.value);
          // Only add if we don't already have a title for this ISBN
          if (!titleMapByIsbn.has(isbnKey)) {
            titleMapByIsbn.set(isbnKey, title);
          }
        }
      });

      // Add valid current titles (won't duplicate because we're using Map with ISBN value as key)
      validCurrentTitles.forEach((ct) => {
        if (ct && ct.value) {
          const isbnKey = String(ct.value);
          // Only add if we don't already have a title for this ISBN
          if (!titleMapByIsbn.has(isbnKey)) {
            titleMapByIsbn.set(isbnKey, ct);
          }
        }
      });

      // Convert back to array, ensuring unique titles by ISBN value
      // This ensures each ISBN only appears once in the title list, preventing duplicates
      const allValidTitles = Array.from(titleMapByIsbn.values());

      // First, ALWAYS update ISBNs to ensure they are selected (even if no titles exist)
      // This ensures ISBNs without titles still remain selected
      // Use the exact value passed in to preserve ALL selected ISBNs
      // Deduplicate ISBNs by value to prevent duplicates
      const rawIsbns = Array.isArray(value) ? value : [];
      const isbnMap = new Map();
      rawIsbns.forEach((isbn: any) => {
        if (isbn && isbn.value) {
          // Use value as key for deduplication (ISBN _id or ISBN number)
          const key = String(isbn.value);
          if (!isbnMap.has(key)) {
            isbnMap.set(key, isbn);
          }
        }
      });
      const finalIsbns = Array.from(isbnMap.values());

      setValue("isbn", finalIsbns, { shouldValidate: true, shouldDirty: true });
      dispatch(UpdateSelectedISBNSList(finalIsbns));
      dispatch(UpdateSelectedISBNS(finalIsbns));

      // Then update titles with those that actually exist for the selected ISBNs
      // If an ISBN has no title, we skip it (don't try to set empty/null titles)
      // But the ISBN itself remains selected above
      setValue("title", allValidTitles, { shouldValidate: true, shouldDirty: true });
      dispatch(UpdateSelectedTitlesList(allValidTitles));
      dispatch(UpdateSelectedTitles(allValidTitles));

      // PRIORITY: Always apply ISBN filter to grid (ISBNs are PRIMARY - show ALL selected ISBNs)
      // DO NOT apply title filter - grid only filters by ISBN, not by title
      handleIsbnFilterChange(finalIsbns);

      // Always remove title filter from grid - we only filter by ISBN
      if (gridApi) {
        const filterModel = gridApi.getFilterModel() || {};
        delete filterModel['FULL_TITLE'];
        gridApi.setFilterModel(filterModel);
        gridApi.onFilterChanged();
      }

      // Reset flag after a delay to allow operations to complete
      delay(50).then(() => {
        isSelectingIsbnsRef.current = false;
      });
    }

  };

  // // Apply a single filter change to the grid
  // const applyIsbnFilterToGrid = (values: any[]) => {
  //   if (!gridApi) return;

  //   const filterModel = gridApi.getFilterModel();

  //   // If all selected values look numeric, use agNumberColumnFilter model so
  //   // the grid's numeric filter UI (greaterThan, inRange, etc.) continues
  //   // to work alongside programmatic equals selections. Otherwise fall back
  //   // to text-based equals conditions.
  //   const isAllNumeric = (arr: any[]) => {
  //     if (!arr || !arr.length) return false;
  //     return arr.every((it) => {
  //       const v = (it && (it.label ?? it.value ?? it))?.toString?.() ?? '';
  //       // treat pure digits (allow leading zeros) as numeric for filtering
  //       return /^\d+$/.test(v.trim());
  //     });
  //   };

  //   if (values && values.length > 0) {
  //     // Extract ISBN values as strings for matching
  //     const isbnValues = values.map((item) => {
  //       const val = (item.label ?? item.value ?? item)?.toString()?.trim();
  //       return val;
  //     }).filter(Boolean);

  //     // Use text filter with OR conditions to match ANY of the selected ISBNs
  //     // This ensures rows matching any selected ISBN are shown
  //     // Using text filter instead of numeric to handle ISBNs with different formats
  //     filterModel['EAN'] = {
  //       filterType: 'text',
  //       operator: 'OR',
  //       conditions: isbnValues.map((isbn) => ({
  //         filterType: 'text',
  //         type: 'equals',
  //         filter: isbn,
  //       })),
  //     };

  //     // Clear other ISBN column filters to avoid AND logic conflicts
  //     // We only filter on EAN column to show rows where EAN matches any selected ISBN
  //     delete filterModel['ISBN'];
  //     delete filterModel['ISBN_9'];
  //     delete filterModel['ISBN_10'];
  //     delete filterModel['PARENT_ISBN'];
  //   } else {
  //     // Clear all ISBN-related column filters
  //     delete filterModel['EAN'];
  //     delete filterModel['ISBN'];
  //     delete filterModel['ISBN_9'];
  //     delete filterModel['ISBN_10'];
  //     delete filterModel['PARENT_ISBN'];
  //   }

  //   gridApi.setFilterModel(filterModel);
  //   gridApi.onFilterChanged();
  // };

  const applyIsbnFilterToGrid = (values: any[]) => {
    if (!gridApi) return;

    // OPTIMIZATION: Prevent duplicate filter applications
    // Clear any pending debounce promise by creating a new one
    // The old promise will still complete but won't affect the new filter

    // Check if filter is already being applied to prevent duplicates
    if (isApplyingFilterRef.current) {
      return; // Skip if already processing
    }

    // Set flag immediately to prevent re-entry
    isApplyingFilterRef.current = true;

    // OPTIMIZATION: Apply filter immediately without debounce to prevent delays and duplicate additions
    // Use requestAnimationFrame to batch with other updates, but don't delay unnecessarily
    requestAnimationFrame(() => {
      if (!gridApi) {
        isApplyingFilterRef.current = false;
        return;
      }

      let filterModel = gridApi.getFilterModel() || {};

      if (values && values.length > 0) {
        // Extract ISBN numbers properly
        // ISBN objects have: { value: _id, label: ISBN_number }
        // We need the actual ISBN number (label) for filtering, not the _id (value)
        // If label doesn't exist, try to find it from numberOptions using the _id

        // OPTIMIZATION: Create a Map for O(1) lookups instead of O(n) find operations
        const numberOptionsMap = new Map<string, any>();
        if (numberOptions && numberOptions.length > 0) {
          numberOptions.forEach((opt: any) => {
            if (opt && opt.value) {
              numberOptionsMap.set(String(opt.value), opt);
            }
          });
        }

        const isbnNumbers: string[] = [];
        const seenIsbns = new Set<string>();

        // OPTIMIZATION: Single pass through values array
        for (let i = 0; i < values.length; i++) {
          const item = values[i];
          if (!item) continue;

          let extractedIsbn: string | null = null;

          // If it's already a string (ISBN number), use it directly
          if (typeof item === 'string') {
            const trimmed = item.trim();
            // Validate it looks like an ISBN
            if (trimmed.length >= 10) {
              extractedIsbn = trimmed;
            }
          }
          // If it's an object, prefer label (actual ISBN number)
          else if (typeof item === 'object') {
            // Label contains the actual ISBN number (e.g., "9781592703180")
            if (item.label) {
              const labelStr = String(item.label).trim();
              if (labelStr.length >= 10) {
                extractedIsbn = labelStr;
              }
            }

            // If no label or label is invalid, try to find it from numberOptionsMap using value (_id)
            // OPTIMIZATION: Use Map.get() instead of Array.find() for O(1) lookup
            if (!extractedIsbn && item.value && numberOptionsMap.size > 0) {
              const foundIsbn = numberOptionsMap.get(String(item.value));
              if (foundIsbn && foundIsbn.label) {
                const foundLabel = String(foundIsbn.label).trim();
                if (foundLabel.length >= 10) {
                  extractedIsbn = foundLabel;
                }
              }
            }

            // Fallback to value if it looks like an ISBN number (starts with 978 or is 10-13 digits)
            if (!extractedIsbn && item.value) {
              const valueStr = String(item.value).trim();
              // Check if value is an ISBN number (not an _id) - ISBNs are typically 10-13 digits
              if (/^(978|979)?\d{10,13}$/.test(valueStr) || (valueStr.length >= 10 && /^\d+$/.test(valueStr))) {
                extractedIsbn = valueStr;
              }
            }
          }

          // Add to array if valid and not already seen
          if (extractedIsbn && !seenIsbns.has(extractedIsbn)) {
            isbnNumbers.push(extractedIsbn);
            seenIsbns.add(extractedIsbn);
          }
        }

        // Use the extracted ISBNs (already deduplicated)
        const uniqueIsbn = isbnNumbers;

        if (uniqueIsbn.length > 0) {
          filterModel['EAN'] = {
            filterType: 'text',
            operator: 'OR',
            conditions: uniqueIsbn.map(val => ({
              filterType: 'text',
              type: 'equals',
              filter: val
            }))
          };
        } else {
          delete filterModel['EAN'];
        }

      } else {
        delete filterModel['EAN'];
      }

      // OPTIMIZATION: Apply filter immediately without additional delays
      // This prevents the 2-3 second delay and duplicate additions
      if (gridApi) {
        gridApi.setFilterModel(filterModel);
        gridApi.onFilterChanged();
      }

      // Reset flag immediately after applying filter
      isApplyingFilterRef.current = false;
    });
  };


  const handleIsbnFilterChange = (values: any[]) => {
    // If ISBN is cleared, also clear title filter from grid since they're interconnected
    if (!values || values.length === 0) {
      // Clear both ISBN and title grid filters
      if (gridApi) {
        const filterModel = gridApi.getFilterModel() || {};
        delete filterModel['EAN'];
        delete filterModel['ISBN'];
        delete filterModel['ISBN_9'];
        delete filterModel['ISBN_10'];
        delete filterModel['PARENT_ISBN'];
        delete filterModel['FULL_TITLE'];
        gridApi.setFilterModel(filterModel);
        gridApi.onFilterChanged();
        setHasGridColumnFilters(Object.keys(filterModel).length > 0);
      }
      return;
    }

    // If data is still loading, queue the filter change
    if (isFetching || !isDataLoadingComplete) {
      pendingFiltersRef.current.push({ type: 'isbn', values });
      return;
    }

    // Data is fully loaded, apply filter immediately
    applyIsbnFilterToGrid(values);
  };

  const applyFilterToGrid = (values: any[], field: string) => {
    if (!gridApi) return;

    // Prevent duplicate filter applications
    if (isApplyingFilterRef.current) return;

    const filterModel = gridApi.getFilterModel() || {};

    // Map form field names to grid column field name prefixes/patterns
    // Note: Division column in SQL is GROUP_1, not DIVISION
    // Note: IMPRINT column in grid is actually "TESTIMPRINTFROMHNA"
    const fieldToColumnPattern: Record<string, string> = {
      "division": "GROUP_1",
      "season": "SEASON",
      "imprint": "TESTIMPRINTFROMHNA", // Grid column is TESTIMPRINTFROMHNA, not IMPRINT
      "format": "FORMAT",
      "managingEditor": "MANAGING_EDITOR",
      "editor": "EDITOR",
      "bisac_status": "BISAC_STATUS",
      "TESTIMPRINTFROMHNA": "TESTIMPRINTFROMHNA", // Direct mapping for TESTIMPRINTFROMHNA field
    };

    // Get the column pattern to search for
    const columnPattern = fieldToColumnPattern[field] || field.toUpperCase();

    // Try to get the actual column field name from the grid API
    let columnFieldName = columnPattern; // Default fallback

    // OPTIMIZATION: Cache column lookup to avoid repeated searches
    const allColumns = gridApi.getColumns();
    if (allColumns && allColumns.length > 0) {
      const patternUpper = columnPattern.toUpperCase();

      // OPTIMIZATION: Use for loop instead of find for better performance
      // Try to find the column that matches the pattern (e.g., "DIVISION = group_1" or "DIVISION")
      let foundColumn = null;
      for (let i = 0; i < allColumns.length; i++) {
        const col = allColumns[i];
        const colDef = col.getColDef();
        const colId = col.getColId() || "";
        const colField = (colDef?.field || "").toUpperCase();

        // Check exact match first (most common case)
        if (colId.toUpperCase() === patternUpper || colField === patternUpper) {
          foundColumn = col;
          break;
        }

        // Extract base field name before "=" or space (for cases like "DIVISION = group_1")
        const baseFieldName = colField.split('=')[0].split(' ')[0].trim();
        if (baseFieldName === patternUpper) {
          foundColumn = col;
          break;
        }

        // Check if column field starts with the pattern
        if (colField && colField.startsWith(patternUpper)) {
          foundColumn = col;
          break;
        }

        // Check if column ID starts with the pattern
        const colIdUpper = colId.toUpperCase();
        if (colIdUpper && colIdUpper.startsWith(patternUpper)) {
          foundColumn = col;
          break;
        }
      }

      // Use the found column's field name
      if (foundColumn) {
        const colDef = foundColumn.getColDef();
        columnFieldName = colDef?.field || foundColumn.getColId() || columnFieldName;
      }
    }

    if (values && values.length > 0) {
      // OPTIMIZATION: Single pass extraction with pre-allocated array
      const filterValues: string[] = [];
      for (let i = 0; i < values.length; i++) {
        const val = values[i];
        if (!val) continue;

        let extracted: string | null = null;
        if (typeof val === "string") {
          extracted = val;
        } else if (typeof val === "object") {
          // Try label first, then value, then the object itself
          extracted = val.label || val.value || val.name || String(val);
        } else {
          extracted = String(val);
        }

        if (extracted) {
          filterValues.push(String(extracted));
        }
      }

      if (filterValues.length > 0) {
        // For IMPRINT and some other fields, use "contains" instead of "equals" 
        // to handle partial matches and case variations
        const useContains = field === "TESTIMPRINTFROMHNA" || field === "imprint" ||
          field === "format" || field === "division" || field === "season";

        filterModel[columnFieldName] = {
          filterType: "text",
          operator: "OR",
          conditions: filterValues.map((filterVal) => ({
            filterType: "text",
            type: useContains ? "contains" : "equals",
            filter: String(filterVal),
          })),
        };
      } else {
        delete filterModel[columnFieldName];
      }
    } else {
      delete filterModel[columnFieldName];
    }

    // OPTIMIZATION: Batch filter model update - only call onFilterChanged once
    // Use requestAnimationFrame for smoother UI updates
    requestAnimationFrame(() => {
      if (gridApi) {
        gridApi.setFilterModel(filterModel);
        gridApi.onFilterChanged();
      }
    });
  };

  const handleFilterChange = (values: any[], field: string) => {
    // If data is still loading, queue the filter change
    if (isFetching || !isDataLoadingComplete) {
      pendingFiltersRef.current.push({ type: 'other', values, field });
      return;
    }

    // Clear any pending debounce promise by creating a new one
    // The old promise will still complete but won't affect the new filter
    filterDebounceTimerRef.current = delay(50).then(() => {
      applyFilterToGrid(values, field);
    });
  };

  const isbnElement = document.getElementById("isbn-selector");
  const titleElement = document.getElementById("title-selector");
  useEffect(() => {
    if (isbnElement) {
      const inner_1st_Div = isbnElement.querySelector("div > div");
      // Find the inner div within the outer div

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }

    if (titleElement) {
      // Find the inner div within the outer div
      const inner_1st_Div = titleElement.querySelector("div > div");

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }

    // if (multiValuContainer[0] || multiValuContainer[1]) {
    //   multiValuContainer[0].scrollLeft = multiValuContainer[0].scrollWidth;
    //   multiValuContainer[1].scrollLeft = multiValuContainer[1].scrollWidth;
    // }
    // },[multiValuContainer[0]?.scrollWidth])
  }, [
    isbnElement?.querySelector("div > div")?.querySelector("div > div")
      ?.scrollWidth,
    titleElement?.querySelector("div > div")?.querySelector("div > div")
      ?.scrollWidth,
    !TitleListReducer.isLoading,
  ]);

  // REMOVED: applyTitleFilterToGrid - Title filtering is no longer used in grid
  // Grid only filters by ISBN, not by title

  // REMOVED: handleTitleFilterChange - Title filtering is no longer used in grid
  // Grid only filters by ISBN, not by title
  const handleAuthorFilterChange = (values: any[]) => {
    if (gridApi) {
      const filterModel = gridApi.getFilterModel();

      if (values && values.length > 0) {
        filterModel["AUTHOR_1"] = {
          filterType: "text",
          operator: "OR",
          conditions: values.map((item) => ({
            filterType: "text",
            type: "equals",
            filter: typeof item === "object" ? item.label || item.value : item,
          })),
        };
      } else {
        delete filterModel["AUTHOR_1"];
      }

      gridApi.setFilterModel(filterModel);
      gridApi.onFilterChanged();
    }
  };


  const CustomHeaderCheckbox = (props: any) => {
    const { displayName, column, api } = props;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <span>{displayName}</span>
        <input
          type="checkbox"
          checked={column.isVisible()}
          onChange={() => api.setColumnsVisible([column.getColId()], !column.isVisible())}

          style={{ marginLeft: 4 }}
          title="Toggle column visibility"
        />
      </div>
    );
  };

  const isExportDisabled = isDownloading || isFetching || !isDataLoadingComplete;

  return (
    <Loading isLoading={
      TitleListReducer.isLoading ||
      isbnReducer.isLoading ||
      authorReducer.isLoading}>
      <div className="w-full">
        <div className="flex items-center w-full px-1 py-1 gap-2">
          <div className="flex justify-between items-center bg-gradient-to-r from-red-500 flex-1 px-3 py-2 text-[20px] font-bold text-white rounded-md">
            TMM Details Export
            <img src={Alogo} alt="" className="w-6 h-6 ml-2" />
          </div>
          <button
            disabled={isExportDisabled}
            className={`${isExportDisabled ? "bg-[#F87171] cursor-not-allowed" : "bg-[#e31c23] cursor-pointer hover:bg-red-700"
              } text-white flex justify-center items-center
                   w-auto px-3 py-1 rounded-md h-[28px] text-xs font-poppins font-semibold border border-none`}
            onClick={exportFilteredRows}
          >
            {isDownloading ? "Exporting..." : "Export"}
          </button>
          <button
            disabled={buttonDisabled}
            className={`${buttonDisabled ? "bg-[#F87171]" : "bg-[#e31c23]"
              } text-white flex ${!buttonDisabled && "hover:bg-red-700"
              } justify-center items-center
                   w-auto px-3 py-1 rounded-md cursor-pointer h-[28px] text-xs font-poppins font-semibold border border-none`}
            onClick={clearAllFilters}
          >
            Clear All Filter
          </button>
        </div>
      </div>
      <div
        style={{ width: "100%", height: "85vh" }}
        className="py-1 ag-theme-alpine flex flex-col h-[90vh] gap-1"
      >
        <style>
          {`
      .ag-theme-alpine .ag-input-field-input.ag-text-field-input {
  padding-left: 24px !important; /* leaves space for search icon */
}

.ag-theme-alpine .ag-input-wrapper .ag-icon {
  left: 4px !important;  /* push icon slightly left */
}


      .ag-theme-alpine .ag-popup,
.ag-theme-alpine .ag-menu {
  background-color: #fff !important;   /* solid white */
  border: 1px solid #ccc !important;   /* light border */
  box-shadow: 0px 2px 8px rgba(0,0,0,0.2); /* better contrast */
}

        .custom-header {
            background-color: #ec1d23 !important;
            color: #fff !important;
            font-weight: bold;
            border: 1px solid #ccc;
            padding: 0 !important;
            margin: 0 !important;
        }
        .custom-header .ag-header-cell-label {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            text-align: center;
        }
        .ag-cell {
            padding-left: 5px !important;

            border: 1px solid #000000ff;
            // padding: 0 !important;
            margin: 0 !important;
            display: flex;
            align-items: center;
            text-align: center;
        }
        .ag-header, .ag-header-cell {
            border-bottom: 1px solid #ccc;
        }
        .ag-floating-filter {
            border: 1px solid #ccc;
        }
        .action-btn {
            margin: 6px;
            padding: 6px 12px;
            background-color: #ec1d23;
            color: #fff;
            border: none;
            cursor: pointer;
            font-weight: bold;
            border-radius: 4px;
        }
        .popup {
            position: fixed;
            top: 0; left: 0;
            width: 100%; height: 100%;
            background: rgba(0,0,0,0.6);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
        }
        .popup-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            text-align: center;
            min-width: 320px;
        }
            .action-btn:disabled {
        background-color: #ccc;
        cursor: not-allowed;
      }

            `}
        </style>
        {/* Filters Section - Top of Grid */}
        {/* <div
  className="w-full bg-red-500 p-1.5 rounded-md border border-gray-300 font-poppins 
  [&_.MuiInputBase-root]:h-[32px] [&_.MuiInputBase-root]:min-h-[32px] [&_.MuiInputBase-root]:max-h-[32px] 
  [&_label]:text-xs [&_label]:mb-0.5"
  title={isFetching || !isDataLoadingComplete ? "Data is loading..." : ""}   // 👈 Tooltip here
> */}
        {/* <div
          className={`
    w-full bg-red-500 p-1.5 rounded-md border border-gray-300 font-poppins
    [&_.MuiInputBase-root]:h-[32px] [&_.MuiInputBase-root]:min-h-[32px] [&_.MuiInputBase-root]:max-h-[32px]
    [&_label]:text-xs [&_label]:mb-0.5
    ${isFetching || !isDataLoadingComplete ? "cursor-not-allowed" : "cursor-auto"}
    `}
          title={isFetching || !isDataLoadingComplete ? "Data is loading..." : ""}
        > */}
        <div
          title={isFetching || !isDataLoadingComplete ? "Preparing data for selection…" : ""}
          className={`
    w-full p-1.5 rounded-md border border-gray-300 font-poppins
    [&_.MuiInputBase-root]:h-[32px] [&_.MuiInputBase-root]:min-h-[32px] [&_.MuiInputBase-root]:max-h-[32px] 
    [&_label]:text-xs [&_label]:mb-0.5
    transition-opacity duration-300  // smooth UI effect
    ${isFetching || !isDataLoadingComplete
              ? "opacity-40 cursor-not-allowed [&_*]:cursor-not-allowed"
              : "opacity-100"
            }
  `}
        >



          {/* First Row - 5 Filters */}
          <div className="grid grid-cols-5 gap-2 mb-1.5">
            <div className="w-full">
              <p className="text-[#e31c23] font-bold text-xs mb-0.5">ISBN</p>
              <div className="w-full relative">
                <Controller
                  control={control}
                  name="isbn"
                  rules={{
                    // onChange: changeIsbnInfo,
                    required: "ISBN is required",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                  }: {
                    field: {
                      onChange: (value: OptionType[] | null) => void;
                      onBlur: () => void;
                      value: OptionType[] | null;
                      name: string;
                      ref: React.Ref<any>;
                    };
                  }) => {
                    interface OptionType {
                      value: string;
                      label: string;
                    }

                    const reorderOptions = (
                      selectedValues: OptionType[] | null | undefined,
                      options: OptionType[]
                    ): OptionType[] => {
                      if (!selectedValues || selectedValues.length === 0)
                        return options;
                      const uniqueSelected = Array.from(
                        new Map(
                          selectedValues.map((item) => [item.value, item])
                        ).values()
                      );
                      const selectedIds = uniqueSelected.map(
                        (selected) => selected.value
                      );
                      const filteredOptions = options.filter(
                        (option) => !selectedIds.includes(option.value)
                      );
                      return [...uniqueSelected, ...filteredOptions];
                    };

                    const reorderedOptions: OptionType[] = reorderOptions(
                      value,
                      isbn_number_options
                    );

                    // Deduplicate the value passed to SelectList
                    const uniqueIsbns: OptionType[] = isbnReducer.selectedISBNSList
                      ? Array.from(
                        new Map(
                          isbnReducer.selectedISBNSList.map((item) => [
                            item.value,
                            item,
                          ])
                        ).values()
                      )
                      : [];

                    return (
                      <div className="relative flex flex-col md:w-full">
                        <SelectList
                          isDisabled={isFetching || !isDataLoadingComplete}
                          filterOption={customFilterOption}
                          classNamePrefix="custom-select"
                          placeholder={"Select ISBN"}
                          onMenuScrollToBottom={() => {
                            if (isbnReducer.hasMoreIsbn) {
                              dispatch(addIsbnPage());
                            }
                          }}
                          isMulti
                          onInputChange={(value: string) => {
                            dispatch(resetIsbnPage());
                            debounceIsbnsSearchStr(value);
                            // dispatch(setIsbnString(value));
                          }}
                          ref={ref}
                          id="isbn-selector"
                          name={name}
                          onBlur={onBlur}
                          // value={uniqueIsbns}
                          value={value}
                          noOptionsMessage={() => "ISBN not found"}
                          components={{
                            MultiValueContainer: (props: any) => (
                              <components.MultiValueContainer {...props}>
                                <div className="flex">{props.children}</div>
                              </components.MultiValueContainer>
                            ),
                            DropdownIndicator: () => null,
                          }}
                          className="border border-solid border-gray-400 font-poppins rounded-lg w-full text-[13px]"
                          styles={{
                            option: (
                              provided: any,
                              state: {
                                isSelected: boolean;
                                isFocused: boolean;
                              }
                            ) => ({
                              ...provided,
                              backgroundColor:
                                state.isSelected || state.isFocused
                                  ? "#E6E6E6"
                                  : "",
                              color: state.isSelected ? "black" : "black",
                            }),
                            input: (provided: any) => ({
                              ...provided,
                              position: `${watch("isbn")?.length ? "relative" : "absolute"
                                }`,
                              left: 6,
                              marginRight: "60px",
                            }),
                            multiValue: (provided: any) => ({
                              ...provided,
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "6px",
                              minWidth: "none",
                            }),
                            menu: (provided: any) => ({
                              ...provided,
                              zIndex: 1050,
                              position: "absolute",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            }),
                            menuPortal: (provided: any) => ({
                              ...provided,
                              zIndex: 1050,
                            }),
                            valueContainer: (provided: any) => ({
                              position: "relative",
                              maxWidth: "100%",
                              width: "100%",
                              paddingLeft: "8px",
                              paddingRight: "8px",
                              display: "flex",
                              alignItems: "center",
                              height: "32px",
                              overflowX: "auto",
                              overflowY: "hidden",
                              minWidth: "0",
                              boxSizing: "border-box",
                            }),
                            control: (provided: any) => ({
                              display: "flex",
                              height: "32px",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                              overflow: "hidden",
                            }),
                            menuList: (provided: any) => ({
                              maxHeight: "200px",
                              overflow: "hidden",
                              overflowY: "auto",
                            }),
                            clearIndicator: (provided: any) => ({
                              ...provided,
                              color: "gray",
                              cursor: "pointer",
                            }),
                          }}
                          onChange={(newValue: any, actionMeta: any) => {
                            // Handle null/undefined case when all items are removed
                            const valueArray = newValue || [];
                            // Deduplicate selected options before passing to onChange
                            const uniqueSelected: any = Array.from(
                              new Map(
                                valueArray.map((item: any) => [item.value, item])
                              ).values()
                            );
                            onChange(uniqueSelected);
                            // Pass the actual selected value to changeIsbnInfo to ensure all ISBNs are preserved
                            changeIsbnInfo({ _rs_name: "isbn", _rs_value: uniqueSelected || [] });

                            // Apply ISBN filter to grid - pass empty array if newValue is null/undefined
                            handleIsbnFilterChange(uniqueSelected || []);
                          }}
                          menuPortalTarget={document.body}
                          menuPlacement="auto"
                          options={reorderedOptions}
                          hideSelectedOptions={false}
                        />
                      </div>
                    );
                  }}
                />
              </div>
            </div>
            <div className="w-full">
              <div className="flex items-center justify-between w-100 ">
                <p className="text-[#e31c23] font-bold "> TITLE</p>
              </div>
              <div className="w-full grid grid-cols-1 relative">
                <Controller
                  control={control}
                  name="title"
                  rules={{
                    // onChange: changeIsbnInfo,
                    required: "Title is required",
                  }}
                  render={({ field: { onChange, onBlur, value, name, ref } }) => {
                    const reorderOptions = (selectedValues: any, options: any) => {
                      if (!selectedValues || selectedValues.length === 0)
                        return options;

                      // Deduplicate selectedValues based on value
                      const uniqueSelected = Array.from(
                        new Map(
                          selectedValues.map((item: any) => [item.value, item])
                        ).values()
                      );
                      const selectedIds = uniqueSelected.map(
                        (selected: any) => selected.value
                      );
                      const filteredOptions = options.filter(
                        (option: any) => !selectedIds.includes(option.value)
                      );
                      return [...uniqueSelected, ...filteredOptions];
                    };

                    const reorderedOptions = reorderOptions(
                      value,
                      isbn_title_options
                    );

                    // Ensure the value passed to SelectList is deduplicated
                    const uniqueTitles = isbnReducer.selectedTitlesList
                      ? Array.from(
                        new Map(
                          isbnReducer.selectedTitlesList.map((item) => [
                            item.value,
                            item,
                          ])
                        ).values()
                      )
                      : [];

                    return (
                      <SelectList
                        filterOption={customFilterOption}
                        classNamePrefix="custom-select"
                        hideSelectedOptions={false}
                        placeholder={"Select Title"}
                        isMulti
                        isDisabled={isFetching || !isDataLoadingComplete}
                        onMenuScrollToBottom={() => {
                          if (isbnReducer.hasMoreIsbn) {
                            dispatch(addIsbnPage());
                          }
                        }}
                        id="title-selector"
                        ref={ref}
                        onInputChange={(value) => {
                          dispatch(resetIsbnPage());
                          if (!onMultiSearchSelect) debounceIsbnsSearchStr(value);
                          // dispatch(setIsbnString(value));
                        }}
                        name={name}
                        onBlur={onBlur}
                        value={value} // Use deduplicated titles
                        components={{
                          MultiValueContainer: (props) => (
                            <components.MultiValueContainer {...props}>
                              <div
                                className="flex w-full"
                                onClick={() => setOnMultiSearchSelect(false)}
                              >
                                {props.children}
                              </div>
                            </components.MultiValueContainer>
                          ),
                          IndicatorsContainer: (props) => (
                            <components.IndicatorsContainer {...props}>
                              <div className="flex items-center gap-2 pr-2">
                                <div className="flex items-center ">
                                  {props.children}
                                </div>
                                {/* <GrCheckboxSelected
                                          className="cursor-pointer text-[15px]"
                                          onClick={handleSelectAllIsbn}
                                          onMouseEnter={() =>
                                            isbnReducer.isbnsString &&
                                            setOnMultiSearchSelect(true)
                                          }
                                          onMouseOut={() => {
                                            setOnMultiSearchSelect(false);
                                          }}
                                        /> */}
                              </div>
                            </components.IndicatorsContainer>
                          ),
                        }}
                        styles={{
                          // Your existing styles remain unchanged
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor:
                              state.isSelected || state.isFocused ? "#E6E6E6" : "",
                            color: state.isSelected ? "black" : "black",
                          }),
                          input: (provided) => ({
                            ...provided,
                            position: `${watch("title")?.length ? "relative" : "absolute"
                              }`,
                            left: 6,
                            marginRight: "60px",
                          }),
                          multiValue: (provided) => ({
                            ...provided,
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "6px",
                            minWidth: "none",
                          }),
                          valueContainer: (provided) => ({
                            position: "relative",
                            maxWidth: "100%",
                            width: "100%",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                            display: "flex",
                            alignItems: "center",
                            height: "32px",
                            overflowX: "auto",
                            overflowY: "hidden",
                            minWidth: "0",
                            boxSizing: "border-box",
                          }),
                          control: (provided) => ({
                            display: "flex",
                            height: "32px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            overflow: "hidden",
                          }),
                          menuList: (provided) => ({
                            maxHeight: "200px",
                            overflow: "hidden",
                            overflowY: "auto",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 1050,
                            position: "absolute",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 1050,
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            color: "gray",
                            cursor: "pointer",
                          }),
                          dropdownIndicator: () => ({
                            display: "none",
                          }),
                        }}
                        noOptionsMessage={() => "Title not found"}
                        className="border border-solid border-gray-400 font-poppins rounded-lg w-full text-[13px]"
                        onChange={(selectedOptions) => {
                          // OPTIMIZATION: Prevent multiple rapid onChange calls that cause flickering
                          if (isSelectingIsbnsRef.current) {
                            return; // Skip if we're already processing a selection
                          }

                          // Handle null/undefined case when all items are removed
                          const optionsArray = selectedOptions || [];

                          // Ensure we have valid items before processing
                          if (!Array.isArray(optionsArray) || optionsArray.length === 0) {
                            onChange([]);
                            changeIsbnInfo({ _rs_name: "title", _rs_value: [] });
                            // No need to call handleTitleFilterChange - grid doesn't use title filter
                            return;
                          }

                          // Deduplicate selected options before passing to onChange
                          const uniqueSelected = Array.from(
                            new Map(
                              optionsArray
                                .filter((item) => item && item.value) // Filter out invalid items
                                .map((item) => [String(item.value), item])
                            ).values()
                          );

                          // Only proceed if we have valid selections
                          // OPTIMIZATION: changeIsbnInfo already handles filter changes, so we don't need to call handleTitleFilterChange separately
                          if (uniqueSelected.length > 0 || optionsArray.length === 0) {
                            // OPTIMIZATION: Create a unique key from selected titles to prevent duplicate processing
                            const selectionKey = uniqueSelected.map((item: any) => String(item.value || item.label || '')).sort().join(',');

                            // Skip if this is the same selection we just processed
                            if (lastTitleSelectionRef.current === selectionKey && isSelectingIsbnsRef.current) {
                              return; // Already processing this selection
                            }

                            // Set flag and track selection immediately to prevent re-entry
                            isSelectingIsbnsRef.current = true;
                            lastTitleSelectionRef.current = selectionKey;

                            // CRITICAL: Don't call onChange here - it causes the add->remove->add flicker
                            // changeIsbnInfo will update the form state via setValue, which automatically
                            // updates the Controller's value. Calling onChange here causes React Select
                            // to show intermediate states (add -> remove -> add)

                            // Process ISBN changes - this will update form state ONCE with final values
                            // changeIsbnInfo calls setValue("title", selectedTitles) which updates the Controller
                            changeIsbnInfo({ _rs_name: "title", _rs_value: uniqueSelected });
                            // Removed duplicate handleTitleFilterChange call - changeIsbnInfo handles it
                          }
                        }}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        options={reorderedOptions}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="w-full">
              <div className="flex items-center justify-between w-100 ">
                <p className="text-[#e31c23] font-bold "> AUTHOR</p>
                {/* <p>select</p> */}
              </div>
              <div className="w-full grid grid-cols-1">
                <Controller
                  control={control}
                  name="author"
                  rules={{
                    required: "Author is required",
                  }}
                  render={({ field: { onChange, onBlur, value, name, ref } }) => {
                    const reorderOptions = (selectedValues: any, options: any) => {
                      if (!selectedValues || selectedValues.length === 0)
                        return options;
                      const selectedIds = selectedValues.map(
                        (selected: any) => selected.value
                      );
                      const filteredOptions = options.filter(
                        (option: any) => !selectedIds.includes(option.value)
                      );
                      return [...selectedValues, ...filteredOptions];
                    };

                    const reorderedOptions = reorderOptions(value, authorOptions);

                    return (
                      <SelectList
                        filterOption={customFilterOption}
                        classNamePrefix="custom-select"
                        placeholder={"Select Author"}
                        isMulti
                        isDisabled={isFetching || !isDataLoadingComplete}
                        hideSelectedOptions={false}
                        onMenuScrollToBottom={() => {
                          if (authorReducer.hasMoreAuthor) {
                            dispatch(addPage());
                          }
                        }}
                        // id="title-selector"
                        ref={ref}
                        onInputChange={(value) => {
                          dispatch(resetAuthorPage());
                          if (!onMultiSearchSelect)
                            debounceUpdateAuthorString(value);
                          // dispatch(setAuthorString(value));
                          // if (value?.length)
                          //   dispatch(updateAuthorPage(1));
                        }}
                        name={name}
                        onBlur={onBlur}
                        // value={authorReducer.Author1List}
                        value={value}
                        components={{
                          MultiValueContainer: (props) => (
                            <components.MultiValueContainer {...props}>
                              <div className="flex w-full">{props.children}</div>
                            </components.MultiValueContainer>
                          ),
                          IndicatorsContainer: (props) => (
                            <components.IndicatorsContainer {...props}>
                              <div className="flex items-center gap-2 pr-2">
                                <div className="flex items-center ">
                                  {props.children}
                                </div>
                                {/* <GrCheckboxSelected
                                          // title={authorReducer.authorString?.length ? `Select all ${authorReducer.authorString} Author records.`:"Select search Author records."}
                                          className="cursor-pointer text-[15px]"
                                          onClick={handleSelectAllAuthors}
                                          onMouseEnter={() =>
                                            authorReducer.authorString
                                              ?.length &&
                                            setOnMultiSearchSelect(true)
                                          }
                                          onMouseOut={() => {
                                            setOnMultiSearchSelect(false);
                                          }}
                                        /> */}
                              </div>
                            </components.IndicatorsContainer>
                          ),
                        }}
                        styles={{
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor:
                              state.isSelected || state.isFocused ? "#E6E6E6" : "",
                            color: state.isSelected ? "black" : "black",
                          }),
                          input: (provided) => ({
                            ...provided,
                            position: `${watch("author")?.length ? "relative" : "absolute"
                              }`,
                            left: 6,
                            marginRight: "60px",
                          }),
                          multiValue: (provided) => ({
                            ...provided,
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "6px",
                            minWidth: "none",
                          }),

                          valueContainer: (provided) => ({
                            position: "relative",
                            maxWidth: "100%",
                            width: "100%",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                            display: "flex",
                            alignItems: "center",
                            height: "32px",
                            overflowX: "auto",
                            overflowY: "hidden",
                            minWidth: "0",
                            boxSizing: "border-box",
                          }),
                          control: (provided) => ({
                            display: "flex",
                            height: "32px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            overflow: "hidden",
                          }),
                          menuList: (provided) => ({
                            maxHeight: "200px",
                            overflow: "hidden",
                            overflowY: "auto",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 1050,
                            position: "absolute",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 1050,
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            color: "gray",
                            cursor: "pointer",
                          }),
                          dropdownIndicator: () => ({
                            display: "none",
                          }),
                        }}
                        noOptionsMessage={() => "Author not found"}
                        className="border border-solid border-gray-400 font-poppins rounded-lg w-full text-[13px]"
                        onChange={(selectedOptions) => {
                          // Handle null/undefined case when all items are removed
                          const optionsArray = selectedOptions || [];

                          // Ensure we have valid items before processing
                          if (!Array.isArray(optionsArray)) {
                            onChange([]);
                            handleAuthorFilterChange([]);
                            return;
                          }

                          // Deduplicate selected options before passing to onChange
                          // React Select already includes all currently selected items in selectedOptions
                          // When removing, selectedOptions will have the updated list (without removed item)
                          // When adding, selectedOptions will have the updated list (with new item)
                          // So we should trust and use selectedOptions directly
                          const uniqueSelected = Array.from(
                            new Map(
                              optionsArray
                                .filter((item) => item && item.value) // Filter out invalid items
                                .map((item) => [String(item.value), item])
                            ).values()
                          );

                          // Update react-hook-form value with the selections from React Select
                          onChange(uniqueSelected);

                          // Apply filter to grid
                          handleAuthorFilterChange(uniqueSelected);
                        }}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        options={reorderedOptions}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="w-full">
              <Controller
                name="season"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    label="SEASON"
                    options={options}
                    selectedValues={field.value || []}
                    onChange={(value) => {
                      field.onChange(value);
                      handleFilterChange(value, "season");
                    }}
                    placeholder="Select Season"
                    disabled={isFetching || !isDataLoadingComplete}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Controller
                name="division"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    label="DIVISION"
                    options={DivisionOption}
                    selectedValues={field.value || []}
                    onChange={(value) => {
                      field.onChange(value);
                      handleFilterChange(value, "division");
                    }}
                    placeholder="Select Division"
                    disabled={isFetching || !isDataLoadingComplete}
                  />
                )}
              />
            </div>
          </div>
          {/* Second Row - 5 Filters */}
          <div className="grid grid-cols-5 gap-2 mb-0">
            <div className="w-full">
              <Controller
                name="imprint"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    label="IMPRINT"
                    options={ImprintOption}
                    selectedValues={field.value || []}
                    onChange={(value) => {
                      field.onChange(value);
                      // Ensure value is an array
                      const valueArray = Array.isArray(value) ? value : (value ? [value] : []);
                      handleFilterChange(valueArray, "TESTIMPRINTFROMHNA");
                    }}
                    placeholder="Select Imprint"
                    disabled={isFetching || !isDataLoadingComplete}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Controller
                name="format"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    label="FORMAT"
                    options={FormatOption}
                    selectedValues={field.value || []}
                    onChange={(value) => {
                      field.onChange(value);
                      handleFilterChange(value, "format");
                    }}
                    placeholder="Select Format"
                    disabled={isFetching || !isDataLoadingComplete}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Controller
                name="managingEditor"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    label="MANAGING EDITOR"
                    options={managingEditorOptions}
                    selectedValues={field.value || []}
                    onChange={(value) => {
                      field.onChange(value);
                      handleFilterChange(value, "MANAGING_EDITOR");
                    }}
                    placeholder="Select Managing Editor"
                    disabled={isFetching || !isDataLoadingComplete}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Controller
                name="editor"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    label="EDITOR"
                    options={editorOptions}
                    selectedValues={field.value || []}
                    onChange={(value) => {
                      field.onChange(value);
                      handleFilterChange(value, "editor");
                    }}
                    placeholder="Select Editor"
                    disabled={isFetching || !isDataLoadingComplete}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Controller
                name="bisac_status"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    label="BISAC STATUS"
                    options={bisacStatusOptions}
                    selectedValues={field.value || []}
                    onChange={(value) => {
                      field.onChange(value);
                      handleFilterChange(value, "bisac_status");
                    }}
                    placeholder="Select BISAC Status"
                    disabled={isFetching || !isDataLoadingComplete}
                  />
                )}
              />
            </div>
          </div>
        </div>

        {/* Popup */}
        {showPopup && (
          <div className="popup">
            <div className="popup-content">
              <h3>Loading Data...</h3>
              <p>Total Records: {totalRecords}</p>
              <p>
                Loaded: {loadedRecords} / {totalRecords}
              </p>
              <div style={{ marginTop: "15px" }}>
                <button
                  className="action-btn"
                  onClick={() => {
                    if (typeof window.startTmmLiveData === "function") {
                      window.startTmmLiveData();
                    }
                  }}
                  disabled={loadedRecords < 1}
                >
                  Go to Live Data Sheet
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Buttons container */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end", // pushes children to the right
            gap: "10px",
            // margin: "10px 0",
            width: "100%", // make sure it takes full width
          }}
        >
          <div style={{ position: "relative" }}>

            {isDownloading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "105%",
                  transform: "translateY(-50%)",
                }}
              >
                {/* Simple spinner */}
                <svg width="20" height="20" viewBox="0 0 50 50">
                  <circle
                    cx="25"
                    cy="25"
                    r="20"
                    stroke="#ec1d23"
                    strokeWidth="5"
                    fill="none"
                    strokeDasharray="31.4 31.4"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      values="0 25 25;360 25 25"
                      dur="1s"
                      repeatCount="indefinite"
                    />
                  </circle>
                </svg>
              </div>
            )}
          </div>
        </div>

        <div
          className="px-2 flex-1 mt-0.5"
          style={{
            background: "#f9f9f9",
          }}
        >
          <AgGridReact
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
            rowData={rowData}
            columnDefs={columnDefs}
            getRowId={(params) => {
              // Priority 1: Use _id if available (database unique identifier - most reliable)
              // This is the best option as _id is guaranteed to be unique
              if (params.data?._id) {
                return String(params.data._id);
              }

              // Priority 2: Build a comprehensive unique key from all available fields
              // This ensures rows with same title+author but different ISBNs/formats are unique
              const uniqueFields = [
                params.data?.EAN,
                params.data?.ISBN,
                params.data?.ISBN_9,
                params.data?.ISBN_10,
                params.data?.PARENT_ISBN,
                params.data?.EBOOK_ISBN,
                params.data?.FULL_TITLE,
                params.data?.AUTHOR_1,
                params.data?.FORMAT,
                params.data?.SEASON,
                params.data?.IMPRINT,
                params.data?.EDITOR,
                params.data?.MANAGING_EDITOR
              ].filter(Boolean).map(String);

              // If we have unique fields, create a composite key
              if (uniqueFields.length > 0) {
                // Join all fields with a separator to create unique ID
                // This ensures different combinations of fields create different IDs
                return uniqueFields.join('||');
              }

              // Final fallback: generate truly unique ID
              // This should never happen if data is properly structured
              return `row-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
            }}
            defaultColDef={{
              sortable: true,
              filter: true,
              resizable: true,
              floatingFilter: true,
              headerComponent: CustomHeaderCheckbox,
            }}
            rowSelection="multiple"
            enableRangeSelection={true}
            enableFillHandle={true}
            clipboardDelimiter="\t"
            pagination={false}
            suppressScrollOnNewData={true}
            animateRows={false}
            overlayNoRowsTemplate={`
      <div style="padding: 15px; font-weight: bold; color: #ec1d23; text-align:center;">
        🚫 No matching records found
      </div>
    `}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end", // pushes everything to the right
            alignItems: "center",
            margin: "5px",
            gap: "15px",
          }}
        >
          {/* Left: Loading info - only show if data is still loading */}
          {loadedRecords < totalRecords && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontWeight: "bold",
              }}
            >
              <p style={{ margin: 0 }}>Loading Data:</p>

              <svg
                width="80"
                height="10"
                viewBox="0 0 50 10"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="50" height="6" fill="#eee" rx="5" />
                <rect width="20" height="6" fill="red" rx="5">
                  <animate
                    attributeName="x"
                    values="0;30;0"
                    dur="1s"
                    repeatCount="indefinite"
                  />
                </rect>
              </svg>

              <div>
                {loadedRecords < totalRecords
                  ? `${loadedRecords} / ${totalRecords}`
                  : `${totalRecords}`}
              </div>
            </div>
          )}
          <button
            className="bg-[#e31c23] text-white flex hover:bg-red-700 justify-center items-center w-[160px] rounded-md cursor-pointer h-[30px] font-poppins font-semibold border border-none action-btn"
            onClick={() => {
              if (gridApi && columnDefs && columnDefs.length > 0) {
                // Gather all field keys (use 'field' or 'colId')
                const allKeys = columnDefs.map(col => col.field || col.colId).filter(Boolean);
                gridApi.setColumnsVisible(allKeys, true);
              }
            }}
          >
            Unhide All Columns
          </button>

          {/* Filtered */}
          <div style={{ fontWeight: "bold" }}>Records</div>

          {/* Displayed count */}
          <div style={{ fontWeight: "bold", textAlign: "center" }}>
            {displayedCount} / {totalRecords}
          </div>
        </div>
      </div>
    </Loading>
  );
};

export default TmmExport;

